const dataArt = {
    id16000: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'David' entre 1501-1504 ?",
        answers: ["Donatello","Barbara Hepworth","Michel-Ange","Henry Moore"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Michel-Ange/David.jpg"
      },
      id16001: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Pietà' entre 1498-1499 ?",
        answers: ["Damien Hirst","Camille Claudel","Donatello","Michel-Ange"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Michel-Ange/La Pietà.jpg"
      },
      id16002: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Moïse' entre 1513-1515 ?",
        answers: ["Michel-Ange","Jean-Antoine Houdon","Donatello","Alberto Giacometti"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Michel-Ange/Moïse.jpg"
      },
      id16003: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Bacchus' entre 1496-1497 ?",
        answers: ["Auguste Rodin","Damien Hirst","Michel-Ange","Le Bernin"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Michel-Ange/Bacchus.jpg"
      },
      id16004: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Madone de Bruges' entre 1504-1506 ?",
        answers: ["Jean-Antoine Houdon","Donatello","Michel-Ange","Damien Hirst"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Michel-Ange/Madone de Bruges.jpg"
      },
      id16005: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Le Prisonnier (L’Esclave mourant)' entre 1513-1516 ?",
        answers: ["Le Bernin","Antonio Canova","Alexander Calder","Michel-Ange"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Michel-Ange/L'esclave mourant.jpg"
      },
      id16006: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Le Prisonnier (L’Esclave rebelle)' entre 1513-1516 ?",
        answers: ["Niki de Saint Phalle","Antony Gormley","Louise Bourgeois","Michel-Ange"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Michel-Ange/L'esclave_Rebelle.jpg"
      },
      id16007: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Tondo Pitti' entre 1504-1505 ?",
        answers: ["Auguste Rodin","Michel-Ange","Donatello","Louise Bourgeois"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Michel-Ange/Tonda Pitti.jpg"
      },
      id16008: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Tombeau de Jules II' entre 1505-1545 ?",
        answers: ["Michel-Ange","Antony Gormley","Le Bernin","Auguste Rodin"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Michel-Ange/Tombeau de Jules II.jpg"
      },
      id16009: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Pietà Rondanini' entre 1555-1564 ?",
        answers: ["Donatello","Michel-Ange","Le Bernin","Louise Bourgeois"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Michel-Ange/Pietà Rondanini.jpg"
      },
      id16010: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'David (bronze)' entre 1408-1409 ?",
        answers: ["Donatello","Michel-Ange","Antonio Canova","Le Bernin"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Donatello/David.jpg"
      },
      id16011: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Saint Marc' entre 1411-1413 ?",
        answers: ["Henry Moore","Donatello","Antonio Canova","Le Bernin"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Donatello/Saint Marc.jpg"
      },
      id16012: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Saint Georges' entre 1415-1417 ?",
        answers: ["Michel-Ange","Damien Hirst","Donatello","Alexander Calder"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Donatello/Saint Georges.jpg"
      },
      id16013: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Monument équestre à Gattamelata' entre 1447-1453 ?",
        answers: ["Michel-Ange","Niki de Saint Phalle","Jean-Antoine Houdon","Donatello"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Donatello/Monument équestre à Gattamelata.jpg"
      },
      id16014: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Madeleine pénitente' entre 1453-1455 ?",
        answers: ["Antony Gormley","Michel-Ange","Auguste Rodin","Donatello"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Donatello/Madeleine pénitente.jpg"
      },
      id16015: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Judith et Holopherne' entre 1457-1464 ?",
        answers: ["Barbara Hepworth","Michel-Ange","Alexander Calder","Donatello"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Donatello/Judith et Holopherne.jpg"
      },
      id16016: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Vierge à l’Enfant (Pazzi Madonna)' entre 1420-1422 ?",
        answers: ["Louise Bourgeois","Henry Moore","Barbara Hepworth","Donatello"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Donatello/La Vierge à l’Enfant.jpg"
      },
      id16017: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Le Festin d’Hérode' entre 1423-1427 ?",
        answers: ["Le Bernin","Auguste Rodin","Jean-Antoine Houdon","Donatello"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/DonatelloLe Festin d’Hérode.jpg"
      },
      id16018: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Cantoria' entre 1433-1439 ?",
        answers: ["Jean-Antoine Houdon","Donatello","Michel-Ange","Barbara Hepworth"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Donatello/Cantoria.jpg"
      },
      id16019: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Apollon et Daphné' entre 1622-1625 ?",
        answers: ["Le Bernin","Jeff Koons","Antony Gormley","Antonio Canova"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Le Bernin/Le Bernin.jpg"
      },
      id16020: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'L’Enlèvement de Proserpine' entre 1621-1622 ?",
        answers: ["Constantin Brâncuși","Le Bernin","Donatello","Jean-Antoine Houdon"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Le BerninLe Bernin.jpg"
      },
      id16021: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'David' entre 1623-1624 ?",
        answers: ["Le Bernin","Jean-Antoine Houdon","Alexander Calder","Camille Claudel"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Le Bernin/David.jpg"
      },
      id16022: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'L’Extase de sainte Thérèse' entre 1647-1652 ?",
        answers: ["Donatello","Le Bernin","Barbara Hepworth","Camille Claudel"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Le Bernin/L’Extase de sainte Thérèse.jpg"
      },
      id16023: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Fontaine des quatre fleuves' entre 1648-1651 ?",
        answers: ["Le Bernin","Niki de Saint Phalle","Antony Gormley","Michel-Ange"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/SculptureLe Bernin/Fontaine des quatre fleuves.jpg"
      },
      id16024: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Buste de Louis XIV' en 1665 ?",
        answers: ["Damien Hirst","Antonio Canova","Le Bernin","Jean-Antoine Houdon"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Le Bernin/Buste de Louis XIV.jpg"
      },
      id16025: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Enée, Anchise et Ascagne' entre 1618-1619 ?",
        answers: ["Michel-Ange","Jean-Antoine Houdon","Louise Bourgeois","Le Bernin"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Le Bernin/Enée, Anchise et Ascagne.jpg"
      },
      id16026: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Baldaquin de Saint-Pierre' entre 1624-1633 ?",
        answers: ["Le Bernin","Donatello","Auguste Rodin","Constantin Brâncuși"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Le Bernin/Baldaquin de Saint-Pierre.jpg"
      },
      id16027: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Vérité dévoilée par le Temps' entre 1645-1652 ?",
        answers: ["Le Bernin","Michel-Ange","Henry Moore","Alberto Giacometti"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Le Bernin/Cantoria.jpg"
      },
      id16028: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Cathedra Petri' entre 1657-1666 ?",
        answers: ["Le Bernin","Jean-Antoine Houdon","Antony Gormley","Michel-Ange"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Le Bernin/La Vérité dévoilée par le Temps.jpg"
      },
      id16029: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Le Penseur' entre 1880-1904 ?",
        answers: ["Damien Hirst","Camille Claudel","Auguste Rodin","Anish Kapoor"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Le Penseur.jpg"
      },
      id16030: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Le Baiser' entre 1882-1889 ?",
        answers: ["Constantin Brâncuși","Camille Claudel","Antonio Canova","Auguste Rodin"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Le Baiser.jpg"
      },
      id16031: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Porte de l’Enfer' entre 1880-1917 ?",
        answers: ["Camille Claudel","Constantin Brâncuși","Auguste Rodin","Damien Hirst"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/La Porte de l’Enfer.jpg"
      },
      id16032: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Les Bourgeois de Calais' entre 1884-1895 ?",
        answers: ["Camille Claudel","Auguste Rodin","Damien Hirst","Barbara Hepworth"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Les Bourgeois de Calais.jpg"
      },
      id16033: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'L’Homme qui marche' entre 1900-1907 ?",
        answers: ["Constantin Brâncuși","Camille Claudel","Auguste Rodin","Alberto Giacometti"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/L’Homme qui marche.jpg"
      },
      id16034: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Monument à Balzac' entre 1891-1898 ?",
        answers: ["Niki de Saint Phalle","Auguste Rodin","Alberto Giacometti","Camille Claudel"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Monument à Balzac.jpg"
      },
      id16035: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Main de Dieu' entre 1898-1902 ?",
        answers: ["Constantin Brâncuși","Henry Moore","Auguste Rodin","Camille Claudel"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/La Main de Dieu.jpg"
      },
      id16036: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Ève' entre 1881 ?",
        answers: ["Antonio Canova","Jeff Koons","Camille Claudel","Auguste Rodin"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Ève.jpg"
      },
      id16037: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'L’Âge d’airain' entre 1876-1877 ?",
        answers: ["Camille Claudel","Niki de Saint Phalle","Barbara Hepworth","Auguste Rodin"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/L’Âge d’airain.jpg"
      },
      id16038: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Fugit Amor' en 1887 ?",
        answers: ["Donatello","Antonio Canova","Auguste Rodin","Camille Claudel"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Fugit Amor.jpg"
      },
      id16039: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'L’Homme au nez cassé' en 1864 ?",
        answers: ["Alexander Calder","Auguste Rodin","Jean-Antoine Houdon","Niki de Saint Phalle"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Cantoria.jpg"
      },
      id16040: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Saint Jean-Baptiste' en 1878 ?",
        answers: ["Camille Claudel","Auguste Rodin","Barbara Hepworth","Constantin Brâncuși"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Cantoria.jpg"
      },
      id16041: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Danaïde' en 1889 ?",
        answers: ["Alexander Calder","Auguste Rodin","Camille Claudel","Damien Hirst"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Cantoria.jpg"
      },
      id16042: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Iris, messagère des dieux' entre 1890-1891 ?",
        answers: ["Camille Claudel","Alberto Giacometti","Constantin Brâncuși","Auguste Rodin"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Cantoria.jpg"
      },
      id16043: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Les Ombres' en 1880 ?",
        answers: ["Niki de Saint Phalle","Barbara Hepworth","Camille Claudel","Auguste Rodin"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Cantoria.jpg"
      },
      id16044: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Défense' en 1879 ?",
        answers: ["Camille Claudel","Niki de Saint Phalle","Auguste Rodin","Constantin Brâncuși"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Cantoria.jpg"
      },
      id16045: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Le Cri' en 1886 ?",
        answers: ["Barbara Hepworth","Alexander Calder","Auguste Rodin","Camille Claudel"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Cantoria.jpg"
      },
      id16046: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Méditation' en 1885 ?",
        answers: ["Michel-Ange","Antonio Canova","Auguste Rodin","Camille Claudel"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Cantoria.jpg"
      },
      id16047: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Victor Hugo' entre 1889-1909 ?",
        answers: ["Camille Claudel","Auguste Rodin","Constantin Brâncuși","Antonio Canova"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Cantoria.jpg"
      },
      id16048: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Les Trois Ombres' en 1886 ?",
        answers: ["Auguste Rodin","Anish Kapoor","Alberto Giacometti","Camille Claudel"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Cantoria.jpg"
      },
      id16049: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'L’Oiseau dans l’espace' entre 1923-1941 ?",
        answers: ["Barbara Hepworth","Alexander Calder","Louise Bourgeois","Constantin Brâncuși"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Constantin Brâncuși/L’Oiseau dans l’espace.jpg"
      },
      id16050: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Colonne sans fin' en 1938 ?",
        answers: ["Auguste Rodin","Constantin Brâncuși","Alexander Calder","Alberto Giacometti"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Constantin Brâncuși/La Colonne sans fin.jpg"
      },
      id16051: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Le Baiser' entre 1907-1916 ?",
        answers: ["Constantin Brâncuși","Alberto Giacometti","Auguste Rodin","Barbara Hepworth"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Constantin Brâncuși/Le Baiser.jpg"
      },
      id16052: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Muse endormie' en 1910 ?",
        answers: ["Alexander Calder","Camille Claudel","Constantin Brâncuși","Auguste Rodin"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Constantin Brâncuși/La Muse endormie.jpg"
      },
      id16053: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Mademoiselle Pogany' entre 1912-1933 ?",
        answers: ["Alberto Giacometti","Constantin Brâncuși","Barbara Hepworth","Anish Kapoor"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Constantin Brâncuși/Mademoiselle Pogany.jpg"
      },
      id16054: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Le Coq' en 1924 ?",
        answers: ["Constantin Brâncuși","Auguste Rodin","Alberto Giacometti","Alexander Calder"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Constantin Brâncuși/Le Coq.jpg"
      },
      id16055: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Table du silence' en 1938 ?",
        answers: ["Auguste Rodin","Constantin Brâncuși","Henry Moore","Alexander Calder"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Constantin Brâncuși/La Table du silence.jpg"
      },
      id16056: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Porte du baiser' en 1938 ?",
        answers: ["Constantin Brâncuși","Camille Claudel","Alexander Calder","Henry Moore"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Constantin Brâncuși/La Porte du baiser.jpg"
      },
      id16057: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Tête de femme' en 1907 ?",
        answers: ["Alexander Calder","Camille Claudel","Jeff Koons","Constantin Brâncuși"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Constantin Brâncuși/Tête de femme.jpg"
      },
      id16058: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Prométhée' en 1911 ?",
        answers: ["Constantin Brâncuși","Auguste Rodin","Anish Kapoor","Le Bernin"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Constantin Brâncuși/Prométhée.jpg"
      },
      id16059: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Psyché ranimée par le baiser de l’Amour' entre 1787-1793 ?",
        answers: ["Jean-Antoine Houdon","Constantin Brâncuși","Jeff Koons","Antonio Canova"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antonio Canova/Psyché ranimée par le baiser de l’Amour.jpg"
      },
      id16060: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Les Trois Grâces' entre 1814-1817 ?",
        answers: ["Auguste Rodin","Antonio Canova","Jean-Antoine Houdon","Antony Gormley"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antonio Canova/Les Trois Grâces.jpg"
      },
      id16061: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Thésée et le Minotaure' entre 1781-1783 ?",
        answers: ["Le Bernin","Antonio Canova","Alexander Calder","Jean-Antoine Houdon"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antonio Canova/Thésée et le Minotaure.jpg"
      },
      id16062: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Amour et Psyché debout' entre 1800-1803 ?",
        answers: ["Auguste Rodin","Alexander Calder","Antonio Canova","Niki de Saint Phalle"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antonio Canova/Amour et Psyché debout.jpg"
      },
      id16063: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Vénus Victrix' entre 1805-1808 ?",
        answers: ["Anish Kapoor","Louise Bourgeois","Jean-Antoine Houdon","Antonio Canova"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antonio Canova/Vénus Victrix.jpg"
      },
      id16064: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Persée triomphant' entre 1804-1806 ?",
        answers: ["Antonio Canova","Constantin Brâncuși","Jean-Antoine Houdon","Auguste Rodin"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antonio Canova/Persée triomphant.jpg"
      },
      id16065: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Hercule et Lichas' entre 1795-1815 ?",
        answers: ["Jean-Antoine Houdon","Camille Claudel","Constantin Brâncuși","Antonio Canova"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antonio Canova/Hercule et Lichas.jpg"
      },
      id16066: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Orphée et Eurydice' entre 1775-1776 ?",
        answers: ["Jean-Antoine Houdon","Antonio Canova","Niki de Saint Phalle","Auguste Rodin"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antonio Canova/Orphée et Eurydice.jpg"
      },
      id16067: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Monument à Marie-Christine d’Autriche' entre 1798-1805 ?",
        answers: ["Jeff Koons","Alberto Giacometti","Auguste Rodin","Antonio Canova"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antonio Canova/Monument à Marie-Christine d’Autriche.jpg"
      },
      id16068: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Danseuse' entre 1811-1812 ?",
        answers: ["Donatello","Antonio Canova","Auguste Rodin","Jean-Antoine Houdon"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antonio Canova/La Danseuse.jpg"
      },
      id16069: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Buste de Voltaire' en 1781 ?",
        answers: ["Auguste Rodin","Antonio Canova","Jean-Antoine Houdon","Alberto Giacometti"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jean-Antoine Houdon/Buste de Voltaire.jpg"
      },
      id16070: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'George Washington' entre 1785-1792 ?",
        answers: ["Camille Claudel","Antonio Canova","Auguste Rodin","Jean-Antoine Houdon"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jean-Antoine Houdon/George Washington.jpg"
      },
      id16071: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Buste de Benjamin Franklin' en 1778 ?",
        answers: ["Antonio Canova","Jean-Antoine Houdon","Constantin Brâncuși","Anish Kapoor"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jean-Antoine Houdon/Buste de Benjamin Franklin.jpg"
      },
      id16072: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Buste de Jean-Jacques Rousseau' en 1788 ?",
        answers: ["Auguste Rodin","Constantin Brâncuși","Antonio Canova","Jean-Antoine Houdon"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jean-Antoine Houdon/Buste de Jean-Jacques Rousseau.jpg"
      },
      id16073: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Diane chasseresse' en 1790 ?",
        answers: ["Jean-Antoine Houdon","Antony Gormley","Antonio Canova","Damien Hirst"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jean-Antoine Houdon/Diane chasseresse.jpg"
      },
      id16074: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Buste de Napoléon' en 1806 ?",
        answers: ["Antonio Canova","Auguste Rodin","Le Bernin","Jean-Antoine Houdon"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jean-Antoine Houdon/Buste de Napoléon.jpg"
      },
      id16075: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'L’Écorché' en 1767 ?",
        answers: ["Jean-Antoine Houdon","Antonio Canova","Camille Claudel","Michel-Ange"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jean-Antoine Houdon/L’Écorché.jpg"
      },
      id16076: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Buste de Diderot' en 1775 ?",
        answers: ["Antonio Canova","Jean-Antoine Houdon","Damien Hirst","Henry Moore"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jean-Antoine Houdon/Buste de Diderot.jpg"
      },
      id16077: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Frileuse' en 1783 ?",
        answers: ["Niki de Saint Phalle","Jean-Antoine Houdon","Louise Bourgeois","Le Bernin"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jean-Antoine Houdon/La Frileuse.jpg"
      },
      id16078: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Buste de Lafayette' en 1789 ?",
        answers: ["Alexander Calder","Antonio Canova","Jean-Antoine Houdon","Auguste Rodin"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jean-Antoine Houdon/Buste de Lafayette.jpg"
      },
      id16079: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Athéna Parthénos' vers 447-438 av. J.-C. ?",
        answers: ["Auguste Rodin","Phidias","Barbara Hepworth","Donatello"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Phidias/Athéna Parthénos.jpg"
      },
      id16080: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Zeus à Olympie' vers 435 av. J.-C. ?",
        answers: ["Donatello","Henry Moore","Phidias","Auguste Rodin"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Phidias/Zeus à Olympie.jpg"
      },
      id16081: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Frise du Parthénon' vers 447-432 av. J.-C. ?",
        answers: ["Louise Bourgeois","Antonio Canova","Jean-Antoine Houdon","Phidias"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Phidias/Frise du Parthénon.jpg"
      },
      id16082: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Métopes du Parthénon' vers 447-442 av. J.-C. ?",
        answers: ["Niki de Saint Phalle","Damien Hirst","Barbara Hepworth","Phidias"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Phidias/Métopes du Parthénon.jpg"
      },
      id16083: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Athéna Lemnia' vers 450 av. J.-C. ?",
        answers: ["Damien Hirst","Antony Gormley","Camille Claudel","Phidias"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Phidias/Athéna Lemnia.jpg"
      },
      id16084: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Statue d’Apollon' vers 460 av. J.-C. ?",
        answers: ["Phidias","Auguste Rodin","Henry Moore","Donatello"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Phidias/Statue d’Apollon.jpg"
      },
      id16085: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Amazone blessée' vers 440 av. J.-C. ?",
        answers: ["Phidias","Auguste Rodin","Henry Moore","Le Bernin"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Phidias/Amazone blessée.jpg"
      },
      id16086: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Frontons du Parthénon' vers 447-432 av. J.-C. ?",
        answers: ["Niki de Saint Phalle","Phidias","Michel-Ange","Louise Bourgeois"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Phidias/Frontons du Parthénon.jpg"
      },
      id16087: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'L’Âge mûr' entre 1895-1900 ?",
        answers: ["Barbara Hepworth","Constantin Brâncuși","Camille Claudel","Auguste Rodin"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Camille Claudel/L’Âge mûr.jpg"
      },
      id16088: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Valse' entre 1889-1905 ?",
        answers: ["Auguste Rodin","Constantin Brâncuși","Camille Claudel","Alexander Calder"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Camille Claudel/La Valse.jpg"
      },
      id16089: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Clotho' en 1893 ?",
        answers: ["Constantin Brâncuși","Alberto Giacometti","Camille Claudel","Auguste Rodin"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Camille Claudel/Clotho.jpg"
      },
      id16090: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Jeune Fille à la gerbe' en 1886 ?",
        answers: ["Antonio Canova","Auguste Rodin","Damien Hirst","Camille Claudel"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Camille Claudel/La Jeune Fille à la gerbe.jpg"
      },
      id16091: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Vertumne et Pomone' entre 1886-1905 ?",
        answers: ["Camille Claudel","Auguste Rodin","Louise Bourgeois","Damien Hirst"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Camille Claudel/Vertumne et Pomone.jpg"
      },
      id16092: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Les Causeuses' en 1897 ?",
        answers: ["Antony Gormley","Auguste Rodin","Constantin Brâncuși","Camille Claudel"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Camille Claudel/Les Causeuses.jpg"
      },
      id16093: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Buste de Rodin' entre 1888-1889 ?",
        answers: ["Alberto Giacometti","Auguste Rodin","Barbara Hepworth","Camille Claudel"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Camille Claudel/Buste de Rodin.jpg"
      },
      id16094: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Petite Châtelaine' entre 1892-1896 ?",
        answers: ["Constantin Brâncuși","Louise Bourgeois","Anish Kapoor","Camille Claudel"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Camille Claudel/La Petite Châtelaine.jpg"
      },
      id16095: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'L’Implorante' entre 1898-1900 ?",
        answers: ["Antonio Canova","Constantin Brâncuși","Auguste Rodin","Camille Claudel"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Camille Claudel/L’Implorante.jpg"
      },
      id16096: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Persée et la Gorgone' entre 1897-1902 ?",
        answers: ["Camille Claudel","Damien Hirst","Auguste Rodin","Alberto Giacometti"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Camille Claudel/Persée et la Gorgone.jpg"
      },
      id16097: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Maman' en 1999 ?",
        answers: ["Jeff Koons","Barbara Hepworth","Antony Gormley","Louise Bourgeois"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Louise Bourgeois/Maman.jpg"
      },
      id16098: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'The Destruction of the Father' en 1974 ?",
        answers: ["Antonio Canova","Alexander Calder","Henry Moore","Louise Bourgeois"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Louise Bourgeois/The Destruction of the Father.jpg"
      },
      id16099: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Cell (Glass Spheres and Hands)' entre 1991-1993 ?",
        answers: ["Anish Kapoor","Jeff Koons","Damien Hirst","Louise Bourgeois"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Louise Bourgeois/Cell (Glass Spheres and Hands).jpg"
      },
      id16100: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Spider' en 1996 ?",
        answers: ["Louise Bourgeois","Niki de Saint Phalle","Jeff Koons","Antony Gormley"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Louise Bourgeois/Spider.jpg"
      },
      id16101: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Femme Maison' entre 1945-1947 ?",
        answers: ["Alberto Giacometti","Auguste Rodin","Louise Bourgeois","Barbara Hepworth"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Louise Bourgeois/Femme Maison.jpg"
      },
      id16102: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Janus Fleuri' en 1968 ?",
        answers: ["Henry Moore","Damien Hirst","Louise Bourgeois","Niki de Saint Phalle"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Louise Bourgeois/Janus Fleuri.jpg"
      },
      id16103: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'The Nest' en 1994 ?",
        answers: ["Antony Gormley","Damien Hirst","Anish Kapoor","Louise Bourgeois"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Louise Bourgeois/The Nest.jpg"
      },
      id16104: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Cumul I' en 1969 ?",
        answers: ["Louise Bourgeois","Alberto Giacometti","Antony Gormley","Barbara Hepworth"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Louise Bourgeois/Cumul I.jpg"
      },
      id16105: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Arch of Hysteria' en 1993 ?",
        answers: ["Henry Moore","Louise Bourgeois","Anish Kapoor","Antony Gormley"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Louise Bourgeois/Arch of Hysteria.jpg"
      },
      id16106: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Precious Liquids' en 1992 ?",
        answers: ["Louise Bourgeois","Antony Gormley","Anish Kapoor","Jeff Koons"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Louise Bourgeois/Precious Liquids.jpg"
      },
      id16107: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Reclining Figure' en 1951 ?",
        answers: ["Henry Moore","Alexander Calder","Niki de Saint Phalle","Alberto Giacometti"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Henry Moore/Reclining Figure.jpg"
      },
      id16108: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Family Group' en 1949 ?",
        answers: ["Henry Moore","Alberto Giacometti","Alexander Calder","Antonio Canova"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Henry Moore/Family Group.jpg"
      },
      id16109: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Large Two Forms' en 1967 ?",
        answers: ["Niki de Saint Phalle","Barbara Hepworth","Alexander Calder","Henry Moore"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Henry Moore/Large Two Forms.jpg"
      },
      id16110: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Sheep Piece' entre 1971-1972 ?",
        answers: ["Alexander Calder","Henry Moore","Niki de Saint Phalle","Barbara Hepworth"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Henry Moore/Sheep Piecee.jpg"
      },
      id16111: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Nuclear Energy' entre 1964-1966 ?",
        answers: ["Henry Moore","Niki de Saint Phalle","Alexander Calder","Antony Gormley"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Henry Moore/Nuclear Energy.jpg"
      },
      id16112: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'King and Queen' entre 1952-1953 ?",
        answers: ["Antony Gormley","Henry Moore","Alexander Calder","Anish Kapoor"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Henry Moore/King and Queen.jpg"
      },
      id16113: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Large Arch' entre 1963-1969 ?",
        answers: ["Henry Moore","Alberto Giacometti","Barbara Hepworth","Niki de Saint Phalle"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Henry Moore/Large Arch.jpg"
      },
      id16114: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Hill Arches' en 1973 ?",
        answers: ["Henry Moore","Damien Hirst","Niki de Saint Phalle","Alexander Calder"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Henry Moore/Hill Arches.jpg"
      },
      id16115: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Mother and Child' en 1939 ?",
        answers: ["Henry Moore","Damien Hirst","Camille Claudel","Constantin Brâncuși"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Henry Moore/Mother and Child.jpg"
      },
      id16116: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Oval with Points' entre 1968-1970 ?",
        answers: ["Louise Bourgeois","Alexander Calder","Barbara Hepworth","Henry Moore"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Henry Moore/Oval with Points.jpg"
      },
      id16117: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'L’Homme qui marche I' en 1960 ?",
        answers: ["Alexander Calder","Alberto Giacometti","Louise Bourgeois","Henry Moore"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alberto Giacometti/L’Homme qui marche I.jpg"
      },
      id16118: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Femme de Venise II' en 1956 ?",
        answers: ["Alexander Calder","Barbara Hepworth","Alberto Giacometti","Niki de Saint Phalle"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alberto Giacometti/Femme de Venise II.jpg"
      },
      id16119: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'L’Homme au doigt' en 1947 ?",
        answers: ["Alberto Giacometti","Constantin Brâncuși","Louise Bourgeois","Barbara Hepworth"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alberto Giacometti/L’Homme au doigt.jpg"
      },
      id16120: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Le Nez' en 1947 ?",
        answers: ["Antonio Canova","Damien Hirst","Alberto Giacometti","Constantin Brâncuși"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alberto Giacometti/Le Nez.jpg"
      },
      id16121: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Main' en 1947 ?",
        answers: ["Alberto Giacometti","Jean-Antoine Houdon","Anish Kapoor","Auguste Rodin"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alberto Giacometti/La Main.jpg"
      },
      id16122: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Femme debout' en 1959 ?",
        answers: ["Niki de Saint Phalle","Constantin Brâncuși","Alberto Giacometti","Barbara Hepworth"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alberto Giacometti/Femme debout.jpg"
      },
      id16123: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Le Chien' en 1951 ?",
        answers: ["Constantin Brâncuși","Alberto Giacometti","Alexander Calder","Niki de Saint Phalle"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alberto Giacometti/Le Chien.jpg"
      },
      id16124: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Forêt' en 1950 ?",
        answers: ["Niki de Saint Phalle","Henry Moore","Louise Bourgeois","Alberto Giacometti"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alberto Giacometti/La Forêt.jpg"
      },
      id16125: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Tête sur tige' en 1947 ?",
        answers: ["Barbara Hepworth","Alexander Calder","Alberto Giacometti","Auguste Rodin"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alberto Giacometti/Tête sur tige.jpg"
      },
      id16126: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Place' en 1948 ?",
        answers: ["Alberto Giacometti","Niki de Saint Phalle","Henry Moore","Auguste Rodin"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alberto Giacometti/La Place.jpg"
      },
      id16127: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Nana' entre 1965-1974 ?",
        answers: ["Louise Bourgeois","Barbara Hepworth","Alexander Calder","Niki de Saint Phalle"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Niki de Saint Phalle/Nana.jpg"
      },
      id16128: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Le Jardin des Tarots' entre 1979-1998 ?",
        answers: ["Anish Kapoor","Louise Bourgeois","Niki de Saint Phalle","Jeff Koons"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Niki de Saint Phalle/Le Jardin des Tarots.jpg"
      },
      id16129: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'L’Ange protecteur' en 1990 ?",
        answers: ["Louise Bourgeois","Henry Moore","Jeff Koons","Niki de Saint Phalle"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Niki de Saint Phalle/L’Ange protecteur.jpg"
      },
      id16130: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Fontaine Stravinsky' en 1983 ?",
        answers: ["Barbara Hepworth","Niki de Saint Phalle","Anish Kapoor","Alexander Calder"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Niki de Saint Phalle/La Fontaine Stravinsky.jpg"
      },
      id16131: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Tirs' entre 1961-1963 ?",
        answers: ["Niki de Saint Phalle","Alexander Calder","Alberto Giacometti","Camille Claudel"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Niki de Saint Phalle/Tirs.jpg"
      },
      id16132: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Golem' en 1972 ?",
        answers: ["Niki de Saint Phalle","Barbara Hepworth","Jeff Koons","Alberto Giacometti"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Niki de Saint Phalle/Golem.jpg"
      },
      id16133: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Hon' en 1966 ?",
        answers: ["Henry Moore","Niki de Saint Phalle","Barbara Hepworth","Louise Bourgeois"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Niki de Saint Phalle/Hon.jpg"
      },
      id16134: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Black Venus' entre 1965-1967 ?",
        answers: ["Barbara Hepworth","Niki de Saint Phalle","Louise Bourgeois","Alberto Giacometti"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Niki de Saint Phalle/Black Venus.jpg"
      },
      id16135: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Sun God' en 1983 ?",
        answers: ["Alberto Giacometti","Alexander Calder","Niki de Saint Phalle","Antony Gormley"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Niki de Saint Phalle/Sun God.jpg"
      },
      id16136: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'L’Oiseau amoureux' en 1970 ?",
        answers: ["Niki de Saint Phalle","Barbara Hepworth","Alexander Calder","Henry Moore"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Niki de Saint Phalle/Nana.jpg"
      },
      id16137: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Lobster Trap and Fish Tail' en 1939 ?",
        answers: ["Alexander Calder","Henry Moore","Alberto Giacometti","Constantin Brâncuși"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alexander Calder/Lobster Trap and Fish Tail.jpg"
      },
      id16138: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Flamingo' en 1973 ?",
        answers: ["Henry Moore","Louise Bourgeois","Alexander Calder","Barbara Hepworth"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alexander Calder/Flamingo.jpg"
      },
      id16139: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'La Grande Vitesse' en 1969 ?",
        answers: ["Barbara Hepworth","Alexander Calder","Niki de Saint Phalle","Henry Moore"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alexander Calder/La Grande Vitesse.jpg"
      },
      id16140: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Mercury Fountain' en 1937 ?",
        answers: ["Alberto Giacometti","Alexander Calder","Constantin Brâncuși","Niki de Saint Phalle"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alexander Calder/Mercury Fountain.jpg"
      },
      id16141: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Black Widow' en 1959 ?",
        answers: ["Damien Hirst","Alberto Giacometti","Alexander Calder","Auguste Rodin"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alexander Calder/Black Widow.jpg"
      },
      id16142: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Spiral' en 1958 ?",
        answers: ["Damien Hirst","Henry Moore","Alberto Giacometti","Alexander Calder"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alexander Calder/Spiral.jpg"
      },
      id16143: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Trois disques' en 1967 ?",
        answers: ["Niki de Saint Phalle","Louise Bourgeois","Henry Moore","Alexander Calder"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alexander Calder/Trois disques.jpg"
      },
      id16144: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Le Guichet' en 1963 ?",
        answers: ["Alberto Giacometti","Alexander Calder","Niki de Saint Phalle","Barbara Hepworth"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alexander Calder/Le Guichet.jpg"
      },
      id16145: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Antennae with Red and Blue Dots' en 1953 ?",
        answers: ["Alberto Giacometti","Alexander Calder","Constantin Brâncuși","Henry Moore"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alexander Calder/Antennae with Red and Blue Dots.jpg"
      },
      id16146: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Eagle' en 1971 ?",
        answers: ["Louise Bourgeois","Alexander Calder","Auguste Rodin","Alberto Giacometti"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alexander Calder/Eagle.jpg"
      },
      id16147: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Balloon Dog' entre 1994-2000 ?",
        answers: ["Louise Bourgeois","Jeff Koons","Anish Kapoor","Antony Gormley"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jeff Koons/Balloon Dog.jpg"
      },
      id16148: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Rabbit' en 1986 ?",
        answers: ["Niki de Saint Phalle","Camille Claudel","Jeff Koons","Antony Gormley"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jeff Koons/Rabbit.jpg"
      },
      id16149: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Puppy' en 1992 ?",
        answers: ["Jeff Koons","Anish Kapoor","Damien Hirst","Louise Bourgeois"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jeff Koons/Puppy.jpg"
      },
      id16150: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Tulips' entre 1995-2004 ?",
        answers: ["Antony Gormley","Alexander Calder","Damien Hirst","Jeff Koons"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jeff Koons/Tulips.jpg"
      },
      id16151: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Inflatable Flower' en 1978 ?",
        answers: ["Jeff Koons","Louise Bourgeois","Antony Gormley","Alberto Giacometti"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jeff Koons/Inflatable Flower.jpg"
      },
      id16152: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Michael Jackson and Bubbles' en 1988 ?",
        answers: ["Louise Bourgeois","Jeff Koons","Niki de Saint Phalle","Damien Hirst"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jeff Koons/Michael Jackson and Bubbles.jpg"
      },
      id16153: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Split-Rocker' en 2000 ?",
        answers: ["Damien Hirst","Jeff Koons","Anish Kapoor","Alexander Calder"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jeff Koons/Split-Rocker.jpg"
      },
      id16154: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Play-Doh' entre 1994-2014 ?",
        answers: ["Damien Hirst","Auguste Rodin","Jeff Koons","Anish Kapoor"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jeff Koons/Play-Doh.jpg"
      },
      id16155: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Gazing Ball (Ariadne)' en 2013 ?",
        answers: ["Damien Hirst","Camille Claudel","Jeff Koons","Anish Kapoor"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jeff Koons/Gazing Ball (Ariadne).jpg"
      },
      id16156: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'The Physical Impossibility of Death in the Mind of Someone Living' en 1991 ?",
        answers: ["Louise Bourgeois","Niki de Saint Phalle","Damien Hirst","Antony Gormley"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Damien Hirst/The Physical Impossibility of Death in the Mind of Someone Living.jpg"
      },
      id16157: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'For the Love of God' en 2007 ?",
        answers: ["Phidias","Damien Hirst","Louise Bourgeois","Alexander Calder"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Damien Hirst/For the Love of God.jpg"
      },
      id16158: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Hymn' entre 1999-2005 ?",
        answers: ["Antony Gormley","Louise Bourgeois","Anish Kapoor","Damien Hirst"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Damien Hirst/Hymn.jpg"
      },
      id16159: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Mother and Child Divided' en 1993 ?",
        answers: ["Henry Moore","Jeff Koons","Louise Bourgeois","Damien Hirst"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Damien Hirst/Mother and Child Divided.jpg"
      },
      id16160: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Away from the Flock' en 1994 ?",
        answers: ["Louise Bourgeois","Antony Gormley","Niki de Saint Phalle","Damien Hirst"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Damien Hirst/Away from the Flock.jpg"
      },
      id16161: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Verity' en 2012 ?",
        answers: ["Jeff Koons","Anish Kapoor","Damien Hirst","Antony Gormley"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Damien Hirst/Verity.jpg"
      },
      id16162: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'The Virgin Mother' entre 2005-2006 ?",
        answers: ["Louise Bourgeois","Anish Kapoor","Damien Hirst","Barbara Hepworth"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Damien Hirst/The Virgin Mother.jpg"
      },
      id16163: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Charity' entre 2002-2003 ?",
        answers: ["Damien Hirst","Anish Kapoor","Antony Gormley","Auguste Rodin"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Damien Hirst/Charity.jpg"
      },
      id16164: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Sphinx' en 2010 ?",
        answers: ["Barbara Hepworth","Antony Gormley","Anish Kapoor","Damien Hirst"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Damien Hirst/Sphinx.jpg"
      },
      id16165: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Temple' en 2008 ?",
        answers: ["Jeff Koons","Damien Hirst","Constantin Brâncuși","Antony Gormley"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Damien Hirst/Temple.jpg"
      },
      id16166: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Cloud Gate' entre 2004-2006 ?",
        answers: ["Anish Kapoor","Jeff Koons","Jean-Antoine Houdon","Damien Hirst"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Anish Kapoor/Cloud Gatea.jpg"
      },
      id16167: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Sky Mirror' en 2006 ?",
        answers: ["Damien Hirst","Anish Kapoor","Alberto Giacometti","Antony Gormley"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Anish Kapoor/Sky Mirror.jpg"
      },
      id16168: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Turning the World Upside Down' en 1995 ?",
        answers: ["Damien Hirst","Anish Kapoor","Antony Gormley","Louise Bourgeois"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Anish Kapoor/Turning the World Upside Down.jpg"
      },
      id16169: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'ArcelorMittal Orbit' en 2012 ?",
        answers: ["Damien Hirst","Alberto Giacometti","Louise Bourgeois","Anish Kapoor"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Anish Kapoor/ArcelorMittal Orbit.jpg"
      },
      id16170: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Dirty Corner' en 2011 ?",
        answers: ["Damien Hirst","Alberto Giacometti","Jeff Koons","Anish Kapoor"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Anish Kapoor/Dirty Corner.jpg"
      },
      id16171: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Leviathan' en 2011 ?",
        answers: ["Louise Bourgeois","Niki de Saint Phalle","Constantin Brâncuși","Anish Kapoor"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Anish Kapoor/Leviathan.jpg"
      },
      id16172: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Monochrome Grave Red' en 2018 ?",
        answers: ["Alberto Giacometti","Anish Kapoor","Damien Hirst","Jeff Koons"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Anish Kapoor/Monochrome Grave Red.jpg"
      },
      id16173: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'My Red Homeland' en 2003 ?",
        answers: ["Jeff Koons","Antony Gormley","Anish Kapoor","Louise Bourgeois"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Anish Kapoor/My Red Homeland.jpg"
      },
      id16174: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Non-Object (Spire)' en 2008 ?",
        answers: ["Damien Hirst","Jeff Koons","Antony Gormley","Anish Kapoor"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Anish Kapoor/Non-Object (Spire).jpg"
      },
      id16175: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'When I Am Pregnant' en 1992 ?",
        answers: ["Louise Bourgeois","Anish Kapoor","Alexander Calder","Jeff Koons"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Anish Kapoor/When I Am Pregnant.jpg"
      },
      id16176: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Angel of the North' en 1998 ?",
        answers: ["Louise Bourgeois","Alexander Calder","Antony Gormley","Jeff Koons"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antony Gormley/Angel of the North.jpg"
      },
      id16177: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Another Place' en 1997 ?",
        answers: ["Anish Kapoor","Antony Gormley","Jeff Koons","Louise Bourgeois"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antony Gormley/Another Place.jpg"
      },
      id16178: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Event Horizon' en 2007 ?",
        answers: ["Jeff Koons","Damien Hirst","Antony Gormley","Anish Kapoor"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antony Gormley/Event Horizon.jpg"
      },
      id16179: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Quantum Cloud' en 1999 ?",
        answers: ["Antony Gormley","Anish Kapoor","Constantin Brâncuși","Jeff Koons"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antony Gormley/Quantum Cloud.jpg"
      },
      id16180: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Field for the British Isles' en 1993 ?",
        answers: ["Jeff Koons","Antony Gormley","Louise Bourgeois","Niki de Saint Phalle"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antony Gormley/Field for the British Isles.jpg"
      },
      id16181: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Critical Mass' en 1995 ?",
        answers: ["Louise Bourgeois","Anish Kapoor","Damien Hirst","Antony Gormley"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antony Gormley/Critical Mass.jpg"
      },
      id16182: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Exposure' en 2010 ?",
        answers: ["Antony Gormley","Jeff Koons","Damien Hirst","Louise Bourgeois"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antony Gormley/Exposure.jpg"
      },
      id16183: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Iron Man' en 1993 ?",
        answers: ["Niki de Saint Phalle","Jeff Koons","Louise Bourgeois","Antony Gormley"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antony Gormley/Iron Man.jpg"
      },
      id16184: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Havmannen' en 1995 ?",
        answers: ["Anish Kapoor","Antony Gormley","Niki de Saint Phalle","Louise Bourgeois"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antony Gormley/Havmannen.jpg"
      },
      id16185: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Sound II' en 1986 ?",
        answers: ["Auguste Rodin","Antony Gormley","Henry Moore","Louise Bourgeois"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antony Gormley/Sound II.jpg"
      },
      id16186: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Single Form' entre 1961-1964 ?",
        answers: ["Barbara Hepworth","Anish Kapoor","Alberto Giacometti","Niki de Saint Phalle"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Barbara Hepworth/Single Form.jpg"
      },
      id16187: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Pierced Form' en 1932 ?",
        answers: ["Constantin Brâncuși","Niki de Saint Phalle","Damien Hirst","Barbara Hepworth"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Barbara Hepworth/Pierced Form.jpg"
      },
      id16188: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Mother and Child' en 1934 ?",
        answers: ["Barbara Hepworth","Auguste Rodin","Alexander Calder","Constantin Brâncuși"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Barbara Hepworth/Mother and Child.jpg"
      },
      id16189: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Pelagos' en 1946 ?",
        answers: ["Louise Bourgeois","Alberto Giacometti","Henry Moore","Barbara Hepworth"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Barbara Hepworth/Pelagos.jpg"
      },
      id16190: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Sphere with Inner Form' en 1963 ?",
        answers: ["Barbara Hepworth","Constantin Brâncuși","Alexander Calder","Le Bernin"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Barbara Hepworth/Sphere with Inner Form.jpg"
      },
      id16191: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Two Forms (Divided Circle)' en 1969 ?",
        answers: ["Henry Moore","Barbara Hepworth","Camille Claudel","Alexander Calder"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Barbara Hepworth/Two Forms (Divided Circle).jpg"
      },
      id16192: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Curved Form (Trevalgan)' en 1956 ?",
        answers: ["Niki de Saint Phalle","Jeff Koons","Barbara Hepworth","Louise Bourgeois"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Barbara Hepworth/Curved Form (Trevalgan).jpg"
      },
      id16193: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Sea Form (Atlantic)' en 1964 ?",
        answers: ["Barbara Hepworth","Louise Bourgeois","Henry Moore","Alexander Calder"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Barbara Hepworth/Sea Form (Atlantic).jpg"
      },
      id16194: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Hollow Form with Inner Form' en 1968 ?",
        answers: ["Barbara Hepworth","Constantin Brâncuși","Louise Bourgeois","Henry Moore"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Barbara Hepworth/Hollow Form with Inner Form.jpg"
      },
      id16195: {
        themes: ["Art","Sculpture"],
        question: "Quel artiste a créé l'œuvre 'Winged Figure' en 1963 ?",
        answers: ["Barbara Hepworth","Alexander Calder","Niki de Saint Phalle","Henry Moore"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Barbara Hepworth/Winged Figure.jpg"
      },
      id16196: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Michel-Ange ?",
        answers: ["6 mars 1475","30 août 1950","7 juin 1965","19 février 1876"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Michel-Ange/David.jpg"
      },
      id16197: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Michel-Ange le 6 mars 1475 ?",
        answers: ["Caprese, Italie","Londres, Royaume-Uni","Naples, Italie","Borgonovo, Suisse"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Michel-Ange/David.jpg"
      },
      id16198: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est mort Michel-Ange ?",
        answers: ["18 février 1564","28 novembre 1680","31 août 1986","13 décembre 1466"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Michel-Ange/David.jpg"
      },
      id16199: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est mort Michel-Ange le 18 février 1564 ?",
        answers: ["Rome, Italie","Meudon, France","Florence, Italie","Venise, Italie"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Michel-Ange/David.jpg"
      },
      id16200: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Michel-Ange ?",
        answers: ["Néoclassicisme","Renaissance","Art contemporain","Modernisme, Abstraction"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Michel-Ange/David.jpg"
      },
      id16201: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Michel-Ange ?",
        answers: ["Suisse","Française","Grecque","Italienne"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Michel-Ange/David.jpg"
      },
      id16202: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Donatello ?",
        answers: ["6 mars 1475","1er novembre 1757","8 décembre 1864","1386"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Donatello/David.jpg"
      },
      id16203: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Donatello le 1386 ?",
        answers: ["Wakefield, Royaume-Uni","Paris, France","Possagno, Italie","Florence, Italie"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Donatello/David.jpg"
      },
      id16204: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est mort Donatello ?",
        answers: ["20 mai 1975","15 juillet 1828","vers 430 av. J.-C.","13 décembre 1466"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Donatello/David.jpg"
      },
      id16205: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est mort Donatello le 13 décembre 1466 ?",
        answers: ["Florence, Italie","Montdevergues, France","Much Hadham, Royaume-Uni","Rome, Italie"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Donatello/David.jpg"
      },
      id16206: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Donatello ?",
        answers: ["Young British Artists, Art contemporain","Renaissance","Surréalisme, Art contemporain","Modernisme, Abstraction"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Donatello/David.jpg"
      },
      id16207: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Donatello ?",
        answers: ["Britannique","Suisse","Française","Italienne"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Donatello/David.jpg"
      },
      id16208: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Le Bernin ?",
        answers: ["7 décembre 1598","12 mars 1954","1386","29 octobre 1930"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Le Bernin/Le Bernin.jpg"
      },
      id16209: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Le Bernin le 7 décembre 1598 ?",
        answers: ["Wakefield, Royaume-Uni","Castleford, Royaume-Uni","Naples, Italie","York, États-Unis"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Le Bernin/Le Bernin.jpg"
      },
      id16210: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est mort Le Bernin ?",
        answers: ["18 février 1564","11 novembre 1976","15 juillet 1828","28 novembre 1680"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Le Bernin/Le Bernin.jpg"
      },
      id16211: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est mort Le Bernin le 28 novembre 1680 ?",
        answers: ["Florence, Italie","Much Hadham, Royaume-Uni","New York, États-Unis","Rome, Italie"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Le Bernin/Le Bernin.jpg"
      },
      id16212: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Le Bernin ?",
        answers: ["Renaissance","Réalisme, Art Nouveau","Baroque","Art contemporain"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Le Bernin/Le Bernin.jpg"
      },
      id16213: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Le Bernin ?",
        answers: ["Italienne","Britannique","Suisse","Française"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Le Bernin/Le Bernin.jpg"
      },
      id16214: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Auguste Rodin ?",
        answers: ["12 novembre 1840","10 octobre 1901","30 juillet 1898","8 décembre 1864"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Le Penseur.jpg"
      },
      id16215: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Auguste Rodin le 12 novembre 1840 ?",
        answers: ["Lawnton, États-Unis","Caprese, Italie","Borgonovo, Suisse","Paris, France"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Le Penseur.jpg"
      },
      id16216: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est mort Auguste Rodin ?",
        answers: ["17 novembre 1917","11 novembre 1976","21 mai 2002","20 mai 1975"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Le Penseur.jpg"
      },
      id16217: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est mort Auguste Rodin le 17 novembre 1917 ?",
        answers: ["Florence, Italie","Coire, Suisse","Olympie ou Athènes, Grèce","Meudon, France"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Le Penseur.jpg"
      },
      id16218: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Auguste Rodin ?",
        answers: ["Nouveau Réalisme, Art contemporain","Réalisme, Impressionnisme","Néoclassicisme","Modernisme, Abstraction"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Le Penseur.jpg"
      },
      id16219: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Auguste Rodin ?",
        answers: ["Française, Américaine","Britannique, Indienne","Française","Italienne"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Auguste Rodin/Le Penseur.jpg"
      },
      id16220: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Constantin Brâncuși ?",
        answers: ["8 décembre 1864","19 février 1876","22 juillet 1898","10 octobre 1901"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Constantin Brâncuși/L’Oiseau dans l’espace.jpg"
      },
      id16221: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Constantin Brâncuși le 19 février 1876 ?",
        answers: ["Londres, Royaume-Uni","Hobița, Roumanie","Castleford, Royaume-Uni","Bombay, Inde"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Constantin Brâncuși/L’Oiseau dans l’espace.jpg"
      },
      id16222: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est mort Constantin Brâncuși ?",
        answers: ["11 novembre 1976","16 mars 1957","20 mai 1975","11 janvier 1966"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Constantin Brâncuși/L’Oiseau dans l’espace.jpg"
      },
      id16223: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est mort Constantin Brâncuși le 16 mars 1957 ?",
        answers: ["Coire, Suisse","Much Hadham, Royaume-Uni","New York, États-Unis","Paris, France"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Constantin Brâncuși/L’Oiseau dans l’espace.jpg"
      },
      id16224: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Constantin Brâncuși ?",
        answers: ["Surréalisme, Art contemporain","Modernisme, Abstraction","Nouveau Réalisme, Art contemporain","Réalisme, Art Nouveau"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Constantin Brâncuși/L’Oiseau dans l’espace.jpg"
      },
      id16225: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Constantin Brâncuși ?",
        answers: ["Britannique","Britannique, Indienne","Roumain","Italienne"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Constantin Brâncuși/L’Oiseau dans l’espace.jpg"
      },
      id16226: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Antonio Canova ?",
        answers: ["1er novembre 1757","29 octobre 1930","12 novembre 1840","20 mars 1741"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antonio Canova/Psyché ranimée par le baiser de l’Amour.jpg"
      },
      id16227: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Antonio Canova le 1er novembre 1757 ?",
        answers: ["York, États-Unis","Versailles, France","Possagno, Italie","Florence, Italie"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antonio Canova/Psyché ranimée par le baiser de l’Amour.jpg"
      },
      id16228: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est mort Antonio Canova ?",
        answers: ["13 décembre 1466","31 août 1986","15 juillet 1828","13 octobre 1822"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antonio Canova/Psyché ranimée par le baiser de l’Amour.jpg"
      },
      id16229: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est mort Antonio Canova le 13 octobre 1822 ?",
        answers: ["Venise, Italie","Rome, Italie","Olympie ou Athènes, Grèce","Meudon, France"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antonio Canova/Psyché ranimée par le baiser de l’Amour.jpg"
      },
      id16230: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Antonio Canova ?",
        answers: ["Surréalisme, Art contemporain","Renaissance","Art contemporain","Néoclassicisme"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antonio Canova/Psyché ranimée par le baiser de l’Amour.jpg"
      },
      id16231: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Antonio Canova ?",
        answers: ["Suisse","Française, Américaine","Italienne","Grecque"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antonio Canova/Psyché ranimée par le baiser de l’Amour.jpg"
      },
      id16232: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Jean-Antoine Houdon ?",
        answers: ["1er novembre 1757","12 mars 1954","7 décembre 1598","20 mars 1741"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jean-Antoine Houdon/Buste de Voltaire.jpg"
      },
      id16233: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Jean-Antoine Houdon le 20 mars 1741 ?",
        answers: ["Neuilly-sur-Seine, France","Bristol, Royaume-Uni","Versailles, France","Athènes, Grèce"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jean-Antoine Houdon/Buste de Voltaire.jpg"
      },
      id16234: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est mort Jean-Antoine Houdon ?",
        answers: ["15 juillet 1828","19 octobre 1943","13 octobre 1822","31 mai 2010"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jean-Antoine Houdon/Buste de Voltaire.jpg"
      },
      id16235: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est mort Jean-Antoine Houdon le 15 juillet 1828 ?",
        answers: ["Florence, Italie","Paris, France","New York, États-Unis","Rome, Italie"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jean-Antoine Houdon/Buste de Voltaire.jpg"
      },
      id16236: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Jean-Antoine Houdon ?",
        answers: ["Néoclassicisme","Art contemporain","Réalisme, Impressionnisme","Renaissance"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jean-Antoine Houdon/Buste de Voltaire.jpg"
      },
      id16237: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Jean-Antoine Houdon ?",
        answers: ["Grecque","Américaine","Française","Britannique, Indienne"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jean-Antoine Houdon/Buste de Voltaire.jpg"
      },
      id16238: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Phidias ?",
        answers: ["6 mars 1475","20 mars 1741","12 mars 1954","vers 490 av. J.-C."],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Phidias/Athéna Parthénos.jpg"
      },
      id16239: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Phidias le vers 490 av. J.-C. ?",
        answers: ["Possagno, Italie","Lawnton, États-Unis","Versailles, France","Athènes, Grèce"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Phidias/Athéna Parthénos.jpg"
      },
      id16240: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est mort Phidias ?",
        answers: ["15 juillet 1828","vers 430 av. J.-C.","11 janvier 1966","31 mai 2010"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Phidias/Athéna Parthénos.jpg"
      },
      id16241: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est mort Phidias le vers 430 av. J.-C. ?",
        answers: ["Venise, Italie","Olympie ou Athènes, Grèce","Meudon, France","Montdevergues, France"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Phidias/Athéna Parthénos.jpg"
      },
      id16242: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Phidias ?",
        answers: ["Réalisme, Art Nouveau","Art classique grec","Surréalisme, Art contemporain","Renaissance"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Phidias/Athéna Parthénos.jpg"
      },
      id16243: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Phidias ?",
        answers: ["Britannique, Indienne","Grecque","Italienne","Britannique"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Phidias/Athéna Parthénos.jpg"
      },
      id16244: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Camille Claudel ?",
        answers: ["8 décembre 1864","30 août 1950","22 juillet 1898","12 novembre 1840"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Camille Claudel/L’Âge mûr.jpg"
      },
      id16245: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Camille Claudel le 8 décembre 1864 ?",
        answers: ["Caprese, Italie","Wakefield, Royaume-Uni","Fère-en-Tardenois, France","Athènes, Grèce"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Camille Claudel/L’Âge mûr.jpg"
      },
      id16246: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est mort Camille Claudel ?",
        answers: ["16 mars 1957","11 novembre 1976","31 mai 2010","19 octobre 1943"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Camille Claudel/L’Âge mûr.jpg"
      },
      id16247: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est mort Camille Claudel le 19 octobre 1943 ?",
        answers: ["Venise, Italie","St Ives, Royaume-Uni","Montdevergues, France","Paris, France"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Camille Claudel/L’Âge mûr.jpg"
      },
      id16248: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Camille Claudel ?",
        answers: ["Modernisme, Abstraction","Surréalisme, Art contemporain","Réalisme, Art Nouveau","Néoclassicisme"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Camille Claudel/L’Âge mûr.jpg"
      },
      id16249: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Camille Claudel ?",
        answers: ["Française","Italienne","Britannique","Suisse"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Camille Claudel/L’Âge mûr.jpg"
      },
      id16250: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Louise Bourgeois ?",
        answers: ["29 octobre 1930","1386","25 décembre 1911","22 juillet 1898"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Louise Bourgeois/Maman.jpg"
      },
      id16251: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Louise Bourgeois le 25 décembre 1911 ?",
        answers: ["Hobița, Roumanie","Paris, France","Borgonovo, Suisse","Possagno, Italie"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Louise Bourgeois/Maman.jpg"
      },
      id16252: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est mort Louise Bourgeois ?",
        answers: ["11 novembre 1976","31 mai 2010","21 mai 2002","31 août 1986"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Louise Bourgeois/Maman.jpg"
      },
      id16253: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est mort Louise Bourgeois le 31 mai 2010 ?",
        answers: ["Olympie ou Athènes, Grèce","New York, États-Unis","Montdevergues, France","Coire, Suisse"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Louise Bourgeois/Maman.jpg"
      },
      id16254: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Louise Bourgeois ?",
        answers: ["Surréalisme, Expressionnisme","Pop Art, Art contemporain","Surréalisme, Art contemporain","Réalisme, Art Nouveau"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Louise Bourgeois/Maman.jpg"
      },
      id16255: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Louise Bourgeois ?",
        answers: ["Britannique, Indienne","Française","Française, Américaine","Britannique"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Louise Bourgeois/Maman.jpg"
      },
      id16256: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Henry Moore ?",
        answers: ["22 juillet 1898","30 juillet 1898","10 janvier 1903","10 octobre 1901"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Henry Moore/Reclining Figure.jpg"
      },
      id16257: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Henry Moore le 30 juillet 1898 ?",
        answers: ["Florence, Italie","Castleford, Royaume-Uni","Versailles, France","Naples, Italie"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Henry Moore/Reclining Figure.jpg"
      },
      id16258: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est mort Henry Moore ?",
        answers: ["20 mai 1975","19 octobre 1943","31 août 1986","11 janvier 1966"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Henry Moore/Reclining Figure.jpg"
      },
      id16259: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est mort Henry Moore le 31 août 1986 ?",
        answers: ["Much Hadham, Royaume-Uni","New York, États-Unis","Coire, Suisse","St Ives, Royaume-Uni"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Henry Moore/Reclining Figure.jpg"
      },
      id16260: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Henry Moore ?",
        answers: ["Modernisme, Abstraction","Art cinétique, Abstraction","Surréalisme, Art contemporain","Surréalisme, Expressionnisme"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Henry Moore/Reclining Figure.jpg"
      },
      id16261: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Henry Moore ?",
        answers: ["Roumain","Britannique, Indienne","Américaine","Britannique"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Henry Moore/Reclining Figure.jpg"
      },
      id16262: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Alberto Giacometti ?",
        answers: ["10 octobre 1901","22 juillet 1898","30 juillet 1898","10 janvier 1903"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alberto Giacometti/L’Homme qui marche I.jpg"
      },
      id16263: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Alberto Giacometti le 10 octobre 1901 ?",
        answers: ["Bristol, Royaume-Uni","Castleford, Royaume-Uni","Bombay, Inde","Borgonovo, Suisse"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alberto Giacometti/L’Homme qui marche I.jpg"
      },
      id16264: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est mort Alberto Giacometti ?",
        answers: ["13 décembre 1466","20 mai 1975","16 mars 1957","11 janvier 1966"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alberto Giacometti/L’Homme qui marche I.jpg"
      },
      id16265: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est mort Alberto Giacometti le 11 janvier 1966 ?",
        answers: ["Coire, Suisse","Florence, Italie","New York, États-Unis","Olympie ou Athènes, Grèce"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alberto Giacometti/L’Homme qui marche I.jpg"
      },
      id16266: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Alberto Giacometti ?",
        answers: ["Art cinétique, Abstraction","Art contemporain","Surréalisme, Expressionnisme","Modernisme, Abstraction"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alberto Giacometti/L’Homme qui marche I.jpg"
      },
      id16267: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Alberto Giacometti ?",
        answers: ["Suisse","Française, Américaine","Britannique","Américaine"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alberto Giacometti/L’Homme qui marche I.jpg"
      },
      id16268: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Niki de Saint Phalle ?",
        answers: ["30 août 1950","25 décembre 1911","29 octobre 1930","30 juillet 1898"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Niki de Saint Phalle/Nana.jpg"
      },
      id16269: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Niki de Saint Phalle le 29 octobre 1930 ?",
        answers: ["Borgonovo, Suisse","Athènes, Grèce","Neuilly-sur-Seine, France","Caprese, Italie"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Niki de Saint Phalle/Nana.jpg"
      },
      id16270: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est mort Niki de Saint Phalle ?",
        answers: ["21 mai 2002","31 août 1986","28 novembre 1680","20 mai 1975"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Niki de Saint Phalle/Nana.jpg"
      },
      id16271: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Niki de Saint Phalle ?",
        answers: ["Pop Art, Art contemporain","Nouveau Réalisme, Art contemporain","Modernisme, Abstraction","Surréalisme, Art contemporain"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Niki de Saint Phalle/Nana.jpg"
      },
      id16272: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Niki de Saint Phalle ?",
        answers: ["Française, Américaine","Américaine","Britannique","Française"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Niki de Saint Phalle/Nana.jpg"
      },
      id16273: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Alexander Calder ?",
        answers: ["30 juillet 1898","10 octobre 1901","22 juillet 1898","10 janvier 1903"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alexander Calder/Lobster Trap and Fish Tail.jpg"
      },
      id16274: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Alexander Calder le 22 juillet 1898 ?",
        answers: ["Neuilly-sur-Seine, France","Possagno, Italie","Lawnton, États-Unis","Bristol, Royaume-Uni"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alexander Calder/Lobster Trap and Fish Tail.jpg"
      },
      id16275: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est mort Alexander Calder ?",
        answers: ["20 mai 1975","31 août 1986","11 novembre 1976","31 mai 2010"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alexander Calder/Lobster Trap and Fish Tail.jpg"
      },
      id16276: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est mort Alexander Calder le 11 novembre 1976 ?",
        answers: ["New York, États-Unis","Rome, Italie","Much Hadham, Royaume-Uni","Paris, France"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alexander Calder/Lobster Trap and Fish Tail.jpg"
      },
      id16277: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Alexander Calder ?",
        answers: ["Art cinétique, Abstraction","Surréalisme, Expressionnisme","Surréalisme, Art contemporain","Modernisme, Abstraction"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alexander Calder/Lobster Trap and Fish Tail.jpg"
      },
      id16278: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Alexander Calder ?",
        answers: ["Roumain","Américaine","Grecque","Française"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Alexander Calder/Lobster Trap and Fish Tail.jpg"
      },
      id16279: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Jeff Koons ?",
        answers: ["7 juin 1965","19 février 1876","21 janvier 1955","12 mars 1954"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jeff Koons/Balloon Dog.jpg"
      },
      id16280: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Jeff Koons le 21 janvier 1955 ?",
        answers: ["Versailles, France","Fère-en-Tardenois, France","Paris, France","York, États-Unis"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jeff Koons/Balloon Dog.jpg"
      },
      id16281: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Jeff Koons ?",
        answers: ["Art contemporain","Surréalisme, Art contemporain","Baroque","Pop Art, Art contemporain"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jeff Koons/Balloon Dog.jpg"
      },
      id16282: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Jeff Koons ?",
        answers: ["Italienne","Grecque","Américaine","Roumain"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Jeff Koons/Balloon Dog.jpg"
      },
      id16283: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Damien Hirst ?",
        answers: ["21 janvier 1955","30 août 1950","12 mars 1954","7 juin 1965"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Damien Hirst/The Physical Impossibility of Death in the Mind of Someone Living.jpg"
      },
      id16284: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Damien Hirst le 7 juin 1965 ?",
        answers: ["Florence, Italie","Bristol, Royaume-Uni","Londres, Royaume-Uni","Bombay, Inde"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Damien Hirst/The Physical Impossibility of Death in the Mind of Someone Living.jpg"
      },
      id16285: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Damien Hirst ?",
        answers: ["Néoclassicisme","Art contemporain","Young British Artists, Art contemporain","Pop Art, Art contemporain"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Damien Hirst/The Physical Impossibility of Death in the Mind of Someone Living.jpg"
      },
      id16286: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Damien Hirst ?",
        answers: ["Française","Grecque","Britannique","Roumain"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Damien Hirst/The Physical Impossibility of Death in the Mind of Someone Living.jpg"
      },
      id16287: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Anish Kapoor ?",
        answers: ["12 mars 1954","30 août 1950","25 décembre 1911","21 janvier 1955"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Anish Kapoor/Cloud Gatea.jpg"
      },
      id16288: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Anish Kapoor le 12 mars 1954 ?",
        answers: ["Paris, France","Castleford, Royaume-Uni","Bombay, Inde","Fère-en-Tardenois, France"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Anish Kapoor/Cloud Gatea.jpg"
      },
      id16289: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Anish Kapoor ?",
        answers: ["Modernisme, Abstraction","Pop Art, Art contemporain","Art contemporain","Young British Artists, Art contemporain"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Anish Kapoor/Cloud Gatea.jpg"
      },
      id16290: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Anish Kapoor ?",
        answers: ["Britannique","Grecque","Italienne","Britannique, Indienne"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Anish Kapoor/Cloud Gatea.jpg"
      },
      id16291: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Antony Gormley ?",
        answers: ["30 juillet 1898","30 août 1950","1386","7 juin 1965"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antony Gormley/Angel of the North.jpg"
      },
      id16292: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Antony Gormley le 30 août 1950 ?",
        answers: ["Naples, Italie","Lawnton, États-Unis","Wakefield, Royaume-Uni","Londres, Royaume-Uni"],
        correctAnswer: 3,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antony Gormley/Angel of the North.jpg"
      },
      id16293: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Antony Gormley ?",
        answers: ["Modernisme, Abstraction","Art contemporain","Surréalisme, Art contemporain","Pop Art, Art contemporain"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antony Gormley/Angel of the North.jpg"
      },
      id16294: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Antony Gormley ?",
        answers: ["Suisse","Italienne","Britannique","Française, Américaine"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Antony Gormley/Angel of the North.jpg"
      },
      id16295: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est né Barbara Hepworth ?",
        answers: ["10 janvier 1903","22 juillet 1898","10 octobre 1901","30 juillet 1898"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Barbara Hepworth/Single Form.jpg"
      },
      id16296: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est né Barbara Hepworth le 10 janvier 1903 ?",
        answers: ["Wakefield, Royaume-Uni","Bombay, Inde","Lawnton, États-Unis","Caprese, Italie"],
        correctAnswer: 0,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Barbara Hepworth/Single Form.jpg"
      },
      id16297: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "En quelle année est mort Barbara Hepworth ?",
        answers: ["21 mai 2002","11 novembre 1976","20 mai 1975","19 octobre 1943"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Barbara Hepworth/Single Form.jpg"
      },
      id16298: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Dans quelle ville est mort Barbara Hepworth le 20 mai 1975 ?",
        answers: ["Coire, Suisse","St Ives, Royaume-Uni","Montdevergues, France","Rome, Italie"],
        correctAnswer: 1,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Barbara Hepworth/Single Form.jpg"
      },
      id16299: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "À quel mouvement artistique appartient Barbara Hepworth ?",
        answers: ["Surréalisme, Expressionnisme","Young British Artists, Art contemporain","Modernisme, Abstraction","Réalisme, Art Nouveau"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Barbara Hepworth/Single Form.jpg"
      },
      id16300: {
        themes: ["Art","Histoire","Sculpture","Culture"],
        question: "Quelle est la nationalité de Barbara Hepworth ?",
        answers: ["Française","Américaine","Britannique","Française, Américaine"],
        correctAnswer: 2,
        box: 1,
        doneToday: null,
        image: "/images/Sculpture/Barbara Hepworth/Single Form.jpg"
      },
      id17000: {
        themes: ["Art","Architecture"],
        question: "En quelle année av. J.-C. le bâtiment 'Ziggurat d’Ur' a-t-il été construit ?",
        answers: ["-1550","-2100","1238","1113"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17001: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Anonyme (civilisation sumérienne), a été construit à Ur, Irak en 2100 av. J.-C. ?",
        answers: ["Pyramides de Gizeh","Stonehenge","Grande Muraille de Chine","Ziggurat d’Ur"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17002: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Ziggurat d’Ur', construit en 2100 av. J.-C. par Anonyme (civilisation sumérienne) ?",
        answers: ["Paris, France","Louxor, Égypte","New York, États-Unis","Ur, Irak"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17003: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Ziggurat d’Ur', construit à Ur, Irak en 2100 av. J.-C. ?",
        answers: ["Anonyme (civilisation néolithique)","Hemiunu","Anonyme (civilisation sumérienne)","Isidore de Milet et Anthémius de Tralles"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17004: {
        themes: ["Art","Architecture"],
        question: "En quelle année av. J.-C. le bâtiment 'Pyramides de Gizeh' a-t-il été construit ?",
        answers: ["1173","-2630","-3000","1930"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17005: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Hemiunu, a été construit à Gizeh, Égypte en 2630 av. J.-C. ?",
        answers: ["Temple de Karnak","Stonehenge","Pyramides de Gizeh","Tour CN"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17006: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Pyramides de Gizeh', construit en 2630 av. J.-C. par Hemiunu ?",
        answers: ["New York, États-Unis","Wiltshire, Royaume-Uni","Louxor, Égypte","Gizeh, Égypte"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17007: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Pyramides de Gizeh', construit à Gizeh, Égypte en 2630 av. J.-C. ?",
        answers: ["Hemiunu","Moshe Safdie","John Andrews et WZMH Architects","Anonyme (civilisation néolithique)"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17008: {
        themes: ["Art","Architecture"],
        question: "En quelle année av. J.-C. le bâtiment 'Parthénon' a-t-il été construit ?",
        answers: ["1173","-447","-437","1971"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17009: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Ictinos et Callicratès, a été construit à Athènes, Grèce en 447 av. J.-C. ?",
        answers: ["Acropole (Propylées)","Casa Milà (La Pedrera)","Parthénon","Grande Muraille de Chine"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17010: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Parthénon', construit en 447 av. J.-C. par Ictinos et Callicratès ?",
        answers: ["Bilbao, Espagne","Chine","Athènes, Grèce","Chambord, France"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17011: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Parthénon', construit à Athènes, Grèce en 447 av. J.-C. ?",
        answers: ["John Andrews et WZMH Architects","Mnésiclès","Ictinos et Callicratès","Divers (dynastie nasride)"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17012: {
        themes: ["Art","Architecture"],
        question: "En quelle année av. J.-C. le bâtiment 'Acropole (Propylées)' a-t-il été construit ?",
        answers: ["-447","1971","-437","1450"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17013: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Mnésiclès, a été construit à Athènes, Grèce en 437 av. J.-C. ?",
        answers: ["Burj Khalifa","Acropole (Propylées)","Parthénon","Golden Gate Bridge"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17014: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Acropole (Propylées)', construit en 437 av. J.-C. par Mnésiclès ?",
        answers: ["Chine","Gizeh, Égypte","Athènes, Grèce","Rome, Italie"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17015: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Acropole (Propylées)', construit à Athènes, Grèce en 437 av. J.-C. ?",
        answers: ["Frank Lloyd Wright","William Van Alen","Ictinos et Callicratès","Mnésiclès"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17016: {
        themes: ["Art","Architecture"],
        question: "En quelle année av. J.-C. le bâtiment 'Grande Muraille de Chine' a-t-il été construit ?",
        answers: ["-221","1869","-437","966"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17017: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Dynastie Qin, a été construit à Chine en 221 av. J.-C. ?",
        answers: ["Grande Muraille de Chine","Temple d’Angkor Vat","Acropole (Propylées)","Mont Saint-Michel"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17018: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Grande Muraille de Chine', construit en 221 av. J.-C. par Dynastie Qin ?",
        answers: ["Barcelone, Espagne","Angkor, Cambodge","Chine","Paris, France"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17019: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Grande Muraille de Chine', construit à Chine en 221 av. J.-C. ?",
        answers: ["Isidore de Milet et Anthémius de Tralles","Dynastie Qin","Divers (5e Dalaï-Lama)","Frank Lloyd Wright"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17020: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Colisée' a-t-il été construit ?",
        answers: ["-1550","1506","537","70"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17021: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Vespasien (commanditaire), a été construit à Rome, Italie en 70 apr. J.-C. ?",
        answers: ["Grande Muraille de Chine","Parthénon","Sainte-Sophie (Hagia Sophia)","Colisée"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17022: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Colisée', construit en 70 apr. J.-C. par Vespasien (commanditaire) ?",
        answers: ["Chambord, France","Athènes, Grèce","Rome, Italie","New York, États-Unis"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17023: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Colisée', construit à Rome, Italie en 70 apr. J.-C. ?",
        answers: ["Christian Jank","William F. Lamb","Vespasien (commanditaire)","Hadrien (attribué)"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17024: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Panthéon' a-t-il été construit ?",
        answers: ["-437","118","1902","70"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17025: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Hadrien (attribué), a été construit à Rome, Italie en 118 apr. J.-C. ?",
        answers: ["Colisée","Panthéon","Machu Picchu","Casa Milà (La Pedrera)"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17026: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Panthéon', construit en 118 apr. J.-C. par Hadrien (attribué) ?",
        answers: ["Athènes, Grèce","New York, États-Unis","Rome, Italie","Pennsylvanie, États-Unis"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17027: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Panthéon', construit à Rome, Italie en 118 apr. J.-C. ?",
        answers: ["Incas (anonymes)","Vespasien (commanditaire)","Jørn Utzon","Hadrien (attribué)"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17028: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Sainte-Sophie (Hagia Sophia)' a-t-il été construit ?",
        answers: ["1887","1994","1993","537"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17029: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Isidore de Milet et Anthémius de Tralles, a été construit à Istanbul, Turquie en 537 apr. J.-C. ?",
        answers: ["Sainte-Sophie (Hagia Sophia)","Palais du Potala","Château de Neuschwanstein","Opéra Garnier"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17030: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Sainte-Sophie (Hagia Sophia)', construit en 537 apr. J.-C. par Isidore de Milet et Anthémius de Tralles ?",
        answers: ["Istanbul, Turquie","Dubaï, Émirats arabes unis","Pérou","Normandie, France"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17031: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Sainte-Sophie (Hagia Sophia)', construit à Istanbul, Turquie en 537 apr. J.-C. ?",
        answers: ["I. M. Pei","Isidore de Milet et Anthémius de Tralles","Anonyme (maîtres d'œuvre)","Antoni Gaudí"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17032: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Temple d’Angkor Vat' a-t-il été construit ?",
        answers: ["1861","1194","1113","1238"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17033: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Suryavarman II (commanditaire), a été construit à Angkor, Cambodge en 1113 apr. J.-C. ?",
        answers: ["Temple d’Angkor Vat","Cathédrale de Chartres","Palais de Westminster","Cathédrale Notre-Dame"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17034: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Temple d’Angkor Vat', construit en 1113 apr. J.-C. par Suryavarman II (commanditaire) ?",
        answers: ["Bavière, Allemagne","Pise, Italie","Angkor, Cambodge","Chartres, France"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17035: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Temple d’Angkor Vat', construit à Angkor, Cambodge en 1113 apr. J.-C. ?",
        answers: ["Ferdinand Cheval","Suryavarman II (commanditaire)","Divers (anonymes médiévaux)","Bonanno Pisano (attribué)"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17036: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Cathédrale Notre-Dame' a-t-il été construit ?",
        answers: ["1173","2009","1194","1163"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17037: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Divers (anonymes médiévaux), a été construit à Paris, France en 1163 apr. J.-C. ?",
        answers: ["Tour de Pise","Cathédrale Notre-Dame","Tour CN","Cathédrale de Chartres"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17038: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Cathédrale Notre-Dame', construit en 1163 apr. J.-C. par Divers (anonymes médiévaux) ?",
        answers: ["Vatican, Italie","Versailles, France","Paris, France","Grenade, Espagne"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17039: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Cathédrale Notre-Dame', construit à Paris, France en 1163 apr. J.-C. ?",
        answers: ["Divers (anonymes médiévaux)","Bonanno Pisano (attribué)","Ustad Ahmad Lahauri","Anonyme (maîtres d'œuvre)"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17040: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Tour de Pise' a-t-il été construit ?",
        answers: ["1163","1173","1194","1519"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17041: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Bonanno Pisano (attribué), a été construit à Pise, Italie en 1173 apr. J.-C. ?",
        answers: ["Tour de Pise","Palais de Westminster","Cathédrale de Chartres","Cathédrale Notre-Dame"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17042: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Tour de Pise', construit en 1173 apr. J.-C. par Bonanno Pisano (attribué) ?",
        answers: ["Pérou","Paris, France","Pise, Italie","Chartres, France"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17043: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Tour de Pise', construit à Pise, Italie en 1173 apr. J.-C. ?",
        answers: ["Anonyme (maîtres d'œuvre)","Bonanno Pisano (attribué)","Divers (anonymes médiévaux)","Domenico da Cortona (attribué)"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17044: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Cathédrale de Chartres' a-t-il été construit ?",
        answers: ["1238","1194","1163","1173"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17045: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Anonyme (maîtres d'œuvre), a été construit à Chartres, France en 1194 apr. J.-C. ?",
        answers: ["Tour de Pise","Chrysler Building","Cathédrale de Chartres","Sagrada Família"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17046: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Cathédrale de Chartres', construit en 1194 apr. J.-C. par Anonyme (maîtres d'œuvre) ?",
        answers: ["Pise, Italie","Angkor, Cambodge","Chartres, France","Londres, Royaume-Uni"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17047: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Cathédrale de Chartres', construit à Chartres, France en 1194 apr. J.-C. ?",
        answers: ["Anonyme (maîtres d'œuvre)","Louis Le Vau et Jules Hardouin-Mansart","Bonanno Pisano (attribué)","I. M. Pei"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17048: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Alhambra' a-t-il été construit ?",
        answers: ["1238","1113","966","1194"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17049: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Divers (dynastie nasride), a été construit à Grenade, Espagne en 1238 apr. J.-C. ?",
        answers: ["Temple d’Angkor Vat","Centre Pompidou","Alhambra","Machu Picchu"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17050: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Alhambra', construit en 1238 apr. J.-C. par Divers (dynastie nasride) ?",
        answers: ["Ur, Irak","Paris, France","Pise, Italie","Grenade, Espagne"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17051: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Alhambra', construit à Grenade, Espagne en 1238 apr. J.-C. ?",
        answers: ["Divers (dynastie nasride)","Suryavarman II (commanditaire)","Domenico da Cortona (attribué)","Anonyme (maîtres d'œuvre)"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17052: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Machu Picchu' a-t-il été construit ?",
        answers: ["1506","1519","1661","1450"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17053: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Incas (anonymes), a été construit à Pérou en 1450 apr. J.-C. ?",
        answers: ["Taj Mahal","Golden Gate Bridge","Sagrada Família","Machu Picchu"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17054: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Machu Picchu', construit en 1450 apr. J.-C. par Incas (anonymes) ?",
        answers: ["Kuala Lumpur, Malaisie","Pérou","Londres, Royaume-Uni","Hauterives, France"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17055: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Machu Picchu', construit à Pérou en 1450 apr. J.-C. ?",
        answers: ["Moshe Safdie","Incas (anonymes)","William Van Alen","Domenico da Cortona (attribué)"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17056: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Saint-Pierre de Rome' a-t-il été construit ?",
        answers: ["1519","1645","1506","1936"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17057: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Michel-Ange et autres, a été construit à Vatican, Italie en 1506 apr. J.-C. ?",
        answers: ["Château de Chambord","Golden Gate Bridge","Palais de Versailles","Saint-Pierre de Rome"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17058: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Saint-Pierre de Rome', construit en 1506 apr. J.-C. par Michel-Ange et autres ?",
        answers: ["Vatican, Italie","Bavière, Allemagne","Agra, Inde","Chambord, France"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17059: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Saint-Pierre de Rome', construit à Vatican, Italie en 1506 apr. J.-C. ?",
        answers: ["Domenico da Cortona (attribué)","Michel-Ange et autres","Divers (anonymes médiévaux)","Divers pharaons"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17060: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Château de Chambord' a-t-il été construit ?",
        answers: ["1506","1519","-1550","1450"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17061: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Domenico da Cortona (attribué), a été construit à Chambord, France en 1519 apr. J.-C. ?",
        answers: ["Palais de Versailles","Saint-Pierre de Rome","Palais du Potala","Château de Chambord"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17062: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Château de Chambord', construit en 1519 apr. J.-C. par Domenico da Cortona (attribué) ?",
        answers: ["Lhassa, Tibet","Chambord, France","Vatican, Italie","Chartres, France"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17063: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Château de Chambord', construit à Chambord, France en 1519 apr. J.-C. ?",
        answers: ["Domenico da Cortona (attribué)","Daniel Burnham","Charles Garnier","Michel-Ange et autres"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17064: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Taj Mahal' a-t-il été construit ?",
        answers: ["1645","-1550","1906","1632"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17065: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Ustad Ahmad Lahauri, a été construit à Agra, Inde en 1632 apr. J.-C. ?",
        answers: ["Taj Mahal","Palais de Versailles","Palais du Potala","Shard"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17066: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Taj Mahal', construit en 1632 apr. J.-C. par Ustad Ahmad Lahauri ?",
        answers: ["Agra, Inde","Vatican, Italie","Lhassa, Tibet","Barcelone, Espagne"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17067: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Taj Mahal', construit à Agra, Inde en 1632 apr. J.-C. ?",
        answers: ["Divers (5e Dalaï-Lama)","Louis Le Vau et Jules Hardouin-Mansart","Ustad Ahmad Lahauri","Incas (anonymes)"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17068: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Palais du Potala' a-t-il été construit ?",
        answers: ["1840","1661","1645","1993"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17069: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Divers (5e Dalaï-Lama), a été construit à Lhassa, Tibet en 1645 apr. J.-C. ?",
        answers: ["Machu Picchu","Palais de Versailles","Taj Mahal","Palais du Potala"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17070: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Palais du Potala', construit en 1645 apr. J.-C. par Divers (5e Dalaï-Lama) ?",
        answers: ["Agra, Inde","Lhassa, Tibet","Versailles, France","Hauterives, France"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17071: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Palais du Potala', construit à Lhassa, Tibet en 1645 apr. J.-C. ?",
        answers: ["Frank Gehry","Ustad Ahmad Lahauri","Divers (5e Dalaï-Lama)","Louis Le Vau et Jules Hardouin-Mansart"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17072: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Palais de Versailles' a-t-il été construit ?",
        answers: ["1661","1113","1882","1645"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17073: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Louis Le Vau et Jules Hardouin-Mansart, a été construit à Versailles, France en 1661 apr. J.-C. ?",
        answers: ["Tour CN","Palais de Versailles","Taj Mahal","Palais du Potala"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17074: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Palais de Versailles', construit en 1661 apr. J.-C. par Louis Le Vau et Jules Hardouin-Mansart ?",
        answers: ["Lhassa, Tibet","Chambord, France","Versailles, France","Sydney, Australie"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17075: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Palais de Versailles', construit à Versailles, France en 1661 apr. J.-C. ?",
        answers: ["Domenico da Cortona (attribué)","Louis Le Vau et Jules Hardouin-Mansart","Ferdinand Cheval","Ustad Ahmad Lahauri"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17076: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Château de Neuschwanstein' a-t-il été construit ?",
        answers: ["1840","1879","1869","1861"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17077: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Christian Jank, a été construit à Bavière, Allemagne en 1869 apr. J.-C. ?",
        answers: ["Tour Eiffel","Palais idéal","Château de Neuschwanstein","Opéra Garnier"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17078: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Château de Neuschwanstein', construit en 1869 apr. J.-C. par Christian Jank ?",
        answers: ["Londres, Royaume-Uni","Paris, France","Hauterives, France","Bavière, Allemagne"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17079: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Château de Neuschwanstein', construit à Bavière, Allemagne en 1869 apr. J.-C. ?",
        answers: ["Charles Barry","Christian Jank","Antoni Gaudí","Charles Garnier"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17080: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Opéra Garnier' a-t-il été construit ?",
        answers: ["1869","1840","966","1861"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17081: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Charles Garnier, a été construit à Paris, France en 1861 apr. J.-C. ?",
        answers: ["Opéra Garnier","Empire State Building","Chrysler Building","Casa Milà (La Pedrera)"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17082: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Opéra Garnier', construit en 1861 apr. J.-C. par Charles Garnier ?",
        answers: ["New York, États-Unis","Lhassa, Tibet","Bavière, Allemagne","Paris, France"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17083: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Opéra Garnier', construit à Paris, France en 1861 apr. J.-C. ?",
        answers: ["William Van Alen","Charles Garnier","Antoni Gaudí","Gustave Eiffel"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17084: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Palais idéal' a-t-il été construit ?",
        answers: ["1869","1971","1879","1882"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17085: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Ferdinand Cheval, a été construit à Hauterives, France en 1879 apr. J.-C. ?",
        answers: ["Tour Eiffel","Palais idéal","Opéra Garnier","Sagrada Família"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17086: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Palais idéal', construit en 1879 apr. J.-C. par Ferdinand Cheval ?",
        answers: ["Singapour","Paris, France","Hauterives, France","Barcelone, Espagne"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17087: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Palais idéal', construit à Hauterives, France en 1879 apr. J.-C. ?",
        answers: ["Antoni Gaudí","Gustave Eiffel","Charles Garnier","Ferdinand Cheval"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17088: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Sagrada Família' a-t-il été construit ?",
        answers: ["1879","1902","1882","1959"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17089: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Antoni Gaudí, a été construit à Barcelone, Espagne en 1882 apr. J.-C. ?",
        answers: ["Flatiron Building","Palais idéal","Tour Eiffel","Sagrada Família"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17090: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Sagrada Família', construit en 1882 apr. J.-C. par Antoni Gaudí ?",
        answers: ["Hauterives, France","Bavière, Allemagne","New York, États-Unis","Barcelone, Espagne"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17091: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Sagrada Família', construit à Barcelone, Espagne en 1882 apr. J.-C. ?",
        answers: ["Daniel Burnham","Gustave Eiffel","Antoni Gaudí","Ferdinand Cheval"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17092: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Tour Eiffel' a-t-il été construit ?",
        answers: ["1879","1887","1882","1930"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17093: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Gustave Eiffel, a été construit à Paris, France en 1887 apr. J.-C. ?",
        answers: ["Sagrada Família","Tour Eiffel","Louvre (Pyramide)","Opéra Garnier"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17094: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Tour Eiffel', construit en 1887 apr. J.-C. par Gustave Eiffel ?",
        answers: ["New York, États-Unis","Paris, France","Barcelone, Espagne","Hauterives, France"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17095: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Tour Eiffel', construit à Paris, France en 1887 apr. J.-C. ?",
        answers: ["Gustave Eiffel","Daniel Burnham","Bonanno Pisano (attribué)","Louis Le Vau et Jules Hardouin-Mansart"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17096: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Louvre (Pyramide)' a-t-il été construit ?",
        answers: ["2010","1994","1933","1989"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17097: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par I. M. Pei, a été construit à Paris, France en 1989 apr. J.-C. ?",
        answers: ["Centre Pompidou","Fallingwater","Louvre (Pyramide)","Shard"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17098: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Louvre (Pyramide)', construit en 1989 apr. J.-C. par I. M. Pei ?",
        answers: ["Kuala Lumpur, Malaisie","Dubaï, Émirats arabes unis","Paris, France","Bilbao, Espagne"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17099: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Louvre (Pyramide)', construit à Paris, France en 1989 apr. J.-C. ?",
        answers: ["I. M. Pei","William F. Lamb","Adrian Smith","Frank Gehry"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17100: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Flatiron Building' a-t-il été construit ?",
        answers: ["1930","1906","1902","1879"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17101: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Daniel Burnham, a été construit à New York, États-Unis en 1902 apr. J.-C. ?",
        answers: ["Flatiron Building","Tour CN","Burj Khalifa","Temple de Karnak"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17102: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Flatiron Building', construit en 1902 apr. J.-C. par Daniel Burnham ?",
        answers: ["Paris, France","New York, États-Unis","Barcelone, Espagne","Singapour"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17103: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Flatiron Building', construit à New York, États-Unis en 1902 apr. J.-C. ?",
        answers: ["Daniel Burnham","Antoni Gaudí","Tom Wright","Gustave Eiffel"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17104: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Casa Milà (La Pedrera)' a-t-il été construit ?",
        answers: ["1879","1887","1930","1906"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17105: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Antoni Gaudí, a été construit à Barcelone, Espagne en 1906 apr. J.-C. ?",
        answers: ["Louvre (Pyramide)","Casa Milà (La Pedrera)","Flatiron Building","Palais idéal"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17106: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Casa Milà (La Pedrera)', construit en 1906 apr. J.-C. par Antoni Gaudí ?",
        answers: ["Bavière, Allemagne","Hauterives, France","Kuala Lumpur, Malaisie","Barcelone, Espagne"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17107: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Casa Milà (La Pedrera)', construit à Barcelone, Espagne en 1906 apr. J.-C. ?",
        answers: ["Anonyme (civilisation néolithique)","William F. Lamb","Antoni Gaudí","Daniel Burnham"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17108: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Chrysler Building' a-t-il été construit ?",
        answers: ["1989","1930","1928","1933"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17109: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par William Van Alen, a été construit à New York, États-Unis en 1928 apr. J.-C. ?",
        answers: ["Empire State Building","Casa Milà (La Pedrera)","Sagrada Família","Chrysler Building"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17110: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Chrysler Building', construit en 1928 apr. J.-C. par William Van Alen ?",
        answers: ["New York, États-Unis","Hauterives, France","Dubaï, Émirats arabes unis","San Francisco, États-Unis"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17111: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Chrysler Building', construit à New York, États-Unis en 1928 apr. J.-C. ?",
        answers: ["Frank Lloyd Wright","William Van Alen","Antoni Gaudí","Ferdinand Cheval"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17112: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Empire State Building' a-t-il été construit ?",
        answers: ["1930","1933","1928","1906"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17113: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par William F. Lamb, a été construit à New York, États-Unis en 1930 apr. J.-C. ?",
        answers: ["One Penn 1","Empire State Building","Opéra Garnier","Château de Neuschwanstein"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17114: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Empire State Building', construit en 1930 apr. J.-C. par William F. Lamb ?",
        answers: ["Pennsylvanie, États-Unis","Dubaï, Émirats arabes unis","San Francisco, États-Unis","New York, États-Unis"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17115: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Empire State Building', construit à New York, États-Unis en 1930 apr. J.-C. ?",
        answers: ["Frank Lloyd Wright","William F. Lamb","Antoni Gaudí","Joseph Strauss (ingénieur)"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17116: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Golden Gate Bridge' a-t-il été construit ?",
        answers: ["1933","-2100","2010","1882"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17117: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Joseph Strauss (ingénieur), a été construit à San Francisco, États-Unis en 1933 apr. J.-C. ?",
        answers: ["Golden Gate Bridge","Empire State Building","Fallingwater","Sydney Opera House"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17118: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Golden Gate Bridge', construit en 1933 apr. J.-C. par Joseph Strauss (ingénieur) ?",
        answers: ["Barcelone, Espagne","New York, États-Unis","San Francisco, États-Unis","Pennsylvanie, États-Unis"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17119: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Golden Gate Bridge', construit à San Francisco, États-Unis en 1933 apr. J.-C. ?",
        answers: ["Antoni Gaudí","Joseph Strauss (ingénieur)","William F. Lamb","Frank Lloyd Wright"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17120: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Fallingwater' a-t-il été construit ?",
        answers: ["1930","2009","2010","1936"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17121: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Frank Lloyd Wright, a été construit à Pennsylvanie, États-Unis en 1936 apr. J.-C. ?",
        answers: ["Golden Gate Bridge","Shard","Fallingwater","Empire State Building"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17122: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Fallingwater', construit en 1936 apr. J.-C. par Frank Lloyd Wright ?",
        answers: ["Sydney, Australie","Pennsylvanie, États-Unis","New York, États-Unis","San Francisco, États-Unis"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17123: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Fallingwater', construit à Pennsylvanie, États-Unis en 1936 apr. J.-C. ?",
        answers: ["César Pelli","Moshe Safdie","Frank Lloyd Wright","Joseph Strauss (ingénieur)"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17124: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Palais de Westminster' a-t-il été construit ?",
        answers: ["1887","1869","1933","1840"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17125: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Charles Barry, a été construit à Londres, Royaume-Uni en 1840 apr. J.-C. ?",
        answers: ["Palais de Westminster","Sagrada Família","Fallingwater","Palais idéal"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17126: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Palais de Westminster', construit en 1840 apr. J.-C. par Charles Barry ?",
        answers: ["Barcelone, Espagne","Londres, Royaume-Uni","Chambord, France","Bilbao, Espagne"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17127: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Palais de Westminster', construit à Londres, Royaume-Uni en 1840 apr. J.-C. ?",
        answers: ["William F. Lamb","William Van Alen","Charles Barry","Christian Jank"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17128: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Sydney Opera House' a-t-il été construit ?",
        answers: ["1930","1936","1933","1959"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17129: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Jørn Utzon, a été construit à Sydney, Australie en 1959 apr. J.-C. ?",
        answers: ["Sydney Opera House","Casa Milà (La Pedrera)","Marina Bay Sands","Golden Gate Bridge"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17130: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Sydney Opera House', construit en 1959 apr. J.-C. par Jørn Utzon ?",
        answers: ["New York, États-Unis","Sydney, Australie","Bilbao, Espagne","Toronto, Canada"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17131: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Sydney Opera House', construit à Sydney, Australie en 1959 apr. J.-C. ?",
        answers: ["Frank Gehry","I. M. Pei","Jørn Utzon","Frank Lloyd Wright"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17132: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'One Penn 1' a-t-il été construit ?",
        answers: ["2004","1971","1973","1969"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17133: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Vlado Architects (rénovation), a été construit à New York, États-Unis en 1969 apr. J.-C. ?",
        answers: ["Centre Pompidou","Louvre (Pyramide)","One Penn 1","Sydney Opera House"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17134: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'One Penn 1', construit en 1969 apr. J.-C. par Vlado Architects (rénovation) ?",
        answers: ["Hauterives, France","Paris, France","New York, États-Unis","Bilbao, Espagne"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17135: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'One Penn 1', construit à New York, États-Unis en 1969 apr. J.-C. ?",
        answers: ["Renzo Piano et Richard Rogers","Vlado Architects (rénovation)","I. M. Pei","Gustave Eiffel"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17136: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Centre Pompidou' a-t-il été construit ?",
        answers: ["1971","1959","1969","1973"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17137: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Renzo Piano et Richard Rogers, a été construit à Paris, France en 1971 apr. J.-C. ?",
        answers: ["Tour Eiffel","Louvre (Pyramide)","Centre Pompidou","Sydney Opera House"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17138: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Centre Pompidou', construit en 1971 apr. J.-C. par Renzo Piano et Richard Rogers ?",
        answers: ["Toronto, Canada","New York, États-Unis","Paris, France","Dubaï, Émirats arabes unis"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17139: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Centre Pompidou', construit à Paris, France en 1971 apr. J.-C. ?",
        answers: ["Daniel Burnham","Renzo Piano et Richard Rogers","Jørn Utzon","John Andrews et WZMH Architects"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17140: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Guggenheim Bilbao' a-t-il été construit ?",
        answers: ["2009","2004","1994","1993"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17141: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Frank Gehry, a été construit à Bilbao, Espagne en 1993 apr. J.-C. ?",
        answers: ["Guggenheim Bilbao","Burj Al Arab","Château de Chambord","Petronas Towers"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17142: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Guggenheim Bilbao', construit en 1993 apr. J.-C. par Frank Gehry ?",
        answers: ["Bilbao, Espagne","Dubaï, Émirats arabes unis","Kuala Lumpur, Malaisie","Toronto, Canada"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17143: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Guggenheim Bilbao', construit à Bilbao, Espagne en 1993 apr. J.-C. ?",
        answers: ["César Pelli","Tom Wright","Frank Gehry","Vlado Architects (rénovation)"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17144: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Petronas Towers' a-t-il été construit ?",
        answers: ["1994","2004","1993","1989"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17145: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par César Pelli, a été construit à Kuala Lumpur, Malaisie en 1993 apr. J.-C. ?",
        answers: ["Burj Khalifa","Guggenheim Bilbao","Petronas Towers","Burj Al Arab"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17146: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Petronas Towers', construit en 1993 apr. J.-C. par César Pelli ?",
        answers: ["Paris, France","Kuala Lumpur, Malaisie","Bilbao, Espagne","Dubaï, Émirats arabes unis"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17147: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Petronas Towers', construit à Kuala Lumpur, Malaisie en 1993 apr. J.-C. ?",
        answers: ["Frank Gehry","César Pelli","Tom Wright","I. M. Pei"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17148: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Burj Al Arab' a-t-il été construit ?",
        answers: ["2004","1993","1519","1994"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17149: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Tom Wright, a été construit à Dubaï, Émirats arabes unis en 1994 apr. J.-C. ?",
        answers: ["One Penn 1","Burj Al Arab","Guggenheim Bilbao","Petronas Towers"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17150: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Burj Al Arab', construit en 1994 apr. J.-C. par Tom Wright ?",
        answers: ["Dubaï, Émirats arabes unis","Sydney, Australie","Istanbul, Turquie","Bilbao, Espagne"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17151: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Burj Al Arab', construit à Dubaï, Émirats arabes unis en 1994 apr. J.-C. ?",
        answers: ["Tom Wright","Joseph Strauss (ingénieur)","Frank Gehry","Adrian Smith"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17152: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Burj Khalifa' a-t-il été construit ?",
        answers: ["1632","1879","1989","2004"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17153: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Adrian Smith, a été construit à Dubaï, Émirats arabes unis en 2004 apr. J.-C. ?",
        answers: ["Fallingwater","One Penn 1","Burj Khalifa","Marina Bay Sands"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17154: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Burj Khalifa', construit en 2004 apr. J.-C. par Adrian Smith ?",
        answers: ["Dubaï, Émirats arabes unis","Kuala Lumpur, Malaisie","Londres, Royaume-Uni","San Francisco, États-Unis"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17155: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Burj Khalifa', construit à Dubaï, Émirats arabes unis en 2004 apr. J.-C. ?",
        answers: ["Moshe Safdie","Adrian Smith","Joseph Strauss (ingénieur)","César Pelli"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17156: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Shard' a-t-il été construit ?",
        answers: ["1994","2009","1989","2010"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17157: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Renzo Piano, a été construit à Londres, Royaume-Uni en 2009 apr. J.-C. ?",
        answers: ["Guggenheim Bilbao","Marina Bay Sands","Sydney Opera House","Shard"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17158: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Shard', construit en 2009 apr. J.-C. par Renzo Piano ?",
        answers: ["Kuala Lumpur, Malaisie","Dubaï, Émirats arabes unis","Londres, Royaume-Uni","Singapour"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17159: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Shard', construit à Londres, Royaume-Uni en 2009 apr. J.-C. ?",
        answers: ["César Pelli","Renzo Piano","I. M. Pei","Moshe Safdie"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17160: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Marina Bay Sands' a-t-il été construit ?",
        answers: ["1969","2010","1989","2009"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17161: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Moshe Safdie, a été construit à Singapour en 2010 apr. J.-C. ?",
        answers: ["Centre Pompidou","Marina Bay Sands","Shard","Palais idéal"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17162: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Marina Bay Sands', construit en 2010 apr. J.-C. par Moshe Safdie ?",
        answers: ["Dubaï, Émirats arabes unis","Singapour","Londres, Royaume-Uni","Bilbao, Espagne"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17163: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Marina Bay Sands', construit à Singapour en 2010 apr. J.-C. ?",
        answers: ["Frank Gehry","Moshe Safdie","I. M. Pei","Renzo Piano"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17164: {
        themes: ["Art","Architecture"],
        question: "En quelle année av. J.-C. le bâtiment 'Stonehenge' a-t-il été construit ?",
        answers: ["1506","-3000","1936","1959"],
        correctAnswer: 1,
        box: 1,
        doneToday: null
      },
      id17165: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Anonyme (civilisation néolithique), a été construit à Wiltshire, Royaume-Uni en 3000 av. J.-C. ?",
        answers: ["Machu Picchu","Château de Chambord","Golden Gate Bridge","Stonehenge"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17166: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Stonehenge', construit en 3000 av. J.-C. par Anonyme (civilisation néolithique) ?",
        answers: ["Ur, Irak","Hauterives, France","Chine","Wiltshire, Royaume-Uni"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17167: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Stonehenge', construit à Wiltshire, Royaume-Uni en 3000 av. J.-C. ?",
        answers: ["Anonyme (civilisation néolithique)","Hemiunu","William Van Alen","Incas (anonymes)"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17168: {
        themes: ["Art","Architecture"],
        question: "En quelle année av. J.-C. le bâtiment 'Temple de Karnak' a-t-il été construit ?",
        answers: ["-221","-2100","-1550","1969"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17169: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Divers pharaons, a été construit à Louxor, Égypte en 1550 av. J.-C. ?",
        answers: ["Sagrada Família","Grande Muraille de Chine","Temple de Karnak","Casa Milà (La Pedrera)"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17170: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Temple de Karnak', construit en 1550 av. J.-C. par Divers pharaons ?",
        answers: ["Lhassa, Tibet","Pennsylvanie, États-Unis","Paris, France","Louxor, Égypte"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17171: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Temple de Karnak', construit à Louxor, Égypte en 1550 av. J.-C. ?",
        answers: ["William F. Lamb","Christian Jank","Ictinos et Callicratès","Divers pharaons"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17172: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Mont Saint-Michel' a-t-il été construit ?",
        answers: ["966","1989","1645","1113"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17173: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par Divers (moines médiévaux), a été construit à Normandie, France en 966 apr. J.-C. ?",
        answers: ["Mont Saint-Michel","Centre Pompidou","Temple d’Angkor Vat","Taj Mahal"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17174: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Mont Saint-Michel', construit en 966 apr. J.-C. par Divers (moines médiévaux) ?",
        answers: ["Normandie, France","Grenade, Espagne","Versailles, France","Bilbao, Espagne"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17175: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Mont Saint-Michel', construit à Normandie, France en 966 apr. J.-C. ?",
        answers: ["Antoni Gaudí","Domenico da Cortona (attribué)","Hadrien (attribué)","Divers (moines médiévaux)"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17176: {
        themes: ["Art","Architecture"],
        question: "En quelle année apr. J.-C. le bâtiment 'Tour CN' a-t-il été construit ?",
        answers: ["1971","1959","1930","1973"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
      id17177: {
        themes: ["Art","Architecture"],
        question: "Quel bâtiment, conçu par John Andrews et WZMH Architects, a été construit à Toronto, Canada en 1973 apr. J.-C. ?",
        answers: ["One Penn 1","Shard","Tour CN","Centre Pompidou"],
        correctAnswer: 2,
        box: 1,
        doneToday: null
      },
      id17178: {
        themes: ["Art","Architecture"],
        question: "Où se trouve le bâtiment 'Tour CN', construit en 1973 apr. J.-C. par John Andrews et WZMH Architects ?",
        answers: ["Toronto, Canada","Bilbao, Espagne","Sydney, Australie","Paris, France"],
        correctAnswer: 0,
        box: 1,
        doneToday: null
      },
      id17179: {
        themes: ["Art","Architecture"],
        question: "Quel architecte a conçu 'Tour CN', construit à Toronto, Canada en 1973 apr. J.-C. ?",
        answers: ["Renzo Piano et Richard Rogers","Vlado Architects (rénovation)","Tom Wright","John Andrews et WZMH Architects"],
        correctAnswer: 3,
        box: 1,
        doneToday: null
      },
    };
    
  export default dataArt;
//  module.exports = dataArt;